/*
 RequireJS 2.1.20 Copyright (c) 2010-2015, The Dojo Foundation All Rights Reserved.
 Available via the MIT or new BSD license.
 see: http://github.com/jrburke/requirejs for details
*/
var requirejs,require,define;
(function(ba){function G(b){return"[object Function]"===K.call(b)}function H(b){return"[object Array]"===K.call(b)}function v(b,c){if(b){var d;for(d=0;d<b.length&&(!b[d]||!c(b[d],d,b));d+=1);}}function T(b,c){if(b){var d;for(d=b.length-1;-1<d&&(!b[d]||!c(b[d],d,b));d-=1);}}function t(b,c){return fa.call(b,c)}function n(b,c){return t(b,c)&&b[c]}function A(b,c){for(var d in b)if(t(b,d)&&c(b[d],d))break}function U(b,c,d,e){c&&A(c,function(c,i){if(d||!t(b,i))e&&"object"===typeof c&&c&&!H(c)&&!G(c)&&!(c instanceof
RegExp)?(b[i]||(b[i]={}),U(b[i],c,d,e)):b[i]=c});return b}function u(b,c){return function(){return c.apply(b,arguments)}}function ca(b){throw b;}function da(b){if(!b)return b;var c=ba;v(b.split("."),function(b){c=c[b]});return c}function B(b,c,d,e){c=Error(c+"\nhttp://requirejs.org/docs/errors.html#"+b);c.requireType=b;c.requireModules=e;d&&(c.originalError=d);return c}function ga(b){function c(a,j,b){var f,l,c,d,h,e,g,i,j=j&&j.split("/"),p=k.map,m=p&&p["*"];if(a){a=a.split("/");l=a.length-1;k.nodeIdCompat&&
Q.test(a[l])&&(a[l]=a[l].replace(Q,""));"."===a[0].charAt(0)&&j&&(l=j.slice(0,j.length-1),a=l.concat(a));l=a;for(c=0;c<l.length;c++)if(d=l[c],"."===d)l.splice(c,1),c-=1;else if(".."===d&&!(0===c||1===c&&".."===l[2]||".."===l[c-1])&&0<c)l.splice(c-1,2),c-=2;a=a.join("/")}if(b&&p&&(j||m)){l=a.split("/");c=l.length;a:for(;0<c;c-=1){h=l.slice(0,c).join("/");if(j)for(d=j.length;0<d;d-=1)if(b=n(p,j.slice(0,d).join("/")))if(b=n(b,h)){f=b;e=c;break a}!g&&(m&&n(m,h))&&(g=n(m,h),i=c)}!f&&g&&(f=g,e=i);f&&(l.splice(0,
e,f),a=l.join("/"))}return(f=n(k.pkgs,a))?f:a}function d(a){z&&v(document.getElementsByTagName("script"),function(j){if(j.getAttribute("data-requiremodule")===a&&j.getAttribute("data-requirecontext")===h.contextName)return j.parentNode.removeChild(j),!0})}function p(a){var j=n(k.paths,a);if(j&&H(j)&&1<j.length)return j.shift(),h.require.undef(a),h.makeRequire(null,{skipMap:!0})([a]),!0}function g(a){var j,c=a?a.indexOf("!"):-1;-1<c&&(j=a.substring(0,c),a=a.substring(c+1,a.length));return[j,a]}function i(a,
j,b,f){var l,d,e=null,i=j?j.name:null,k=a,p=!0,m="";a||(p=!1,a="_@r"+(K+=1));a=g(a);e=a[0];a=a[1];e&&(e=c(e,i,f),d=n(q,e));a&&(e?m=d&&d.normalize?d.normalize(a,function(a){return c(a,i,f)}):-1===a.indexOf("!")?c(a,i,f):a:(m=c(a,i,f),a=g(m),e=a[0],m=a[1],b=!0,l=h.nameToUrl(m)));b=e&&!d&&!b?"_unnormalized"+(O+=1):"";return{prefix:e,name:m,parentMap:j,unnormalized:!!b,url:l,originalName:k,isDefine:p,id:(e?e+"!"+m:m)+b}}function r(a){var j=a.id,b=n(m,j);b||(b=m[j]=new h.Module(a));return b}function s(a,
j,b){var f=a.id,c=n(m,f);if(t(q,f)&&(!c||c.defineEmitComplete))"defined"===j&&b(q[f]);else if(c=r(a),c.error&&"error"===j)b(c.error);else c.on(j,b)}function w(a,b){var c=a.requireModules,f=!1;if(b)b(a);else if(v(c,function(b){if(b=n(m,b))b.error=a,b.events.error&&(f=!0,b.emit("error",a))}),!f)e.onError(a)}function x(){R.length&&(v(R,function(a){var b=a[0];"string"===typeof b&&(h.defQueueMap[b]=!0);C.push(a)}),R=[])}function y(a){delete m[a];delete V[a]}function F(a,b,c){var f=a.map.id;a.error?a.emit("error",
a.error):(b[f]=!0,v(a.depMaps,function(f,d){var e=f.id,h=n(m,e);h&&(!a.depMatched[d]&&!c[e])&&(n(b,e)?(a.defineDep(d,q[e]),a.check()):F(h,b,c))}),c[f]=!0)}function D(){var a,b,c=(a=1E3*k.waitSeconds)&&h.startTime+a<(new Date).getTime(),f=[],l=[],e=!1,i=!0;if(!W){W=!0;A(V,function(a){var h=a.map,g=h.id;if(a.enabled&&(h.isDefine||l.push(a),!a.error))if(!a.inited&&c)p(g)?e=b=!0:(f.push(g),d(g));else if(!a.inited&&(a.fetched&&h.isDefine)&&(e=!0,!h.prefix))return i=!1});if(c&&f.length)return a=B("timeout",
"Load timeout for modules: "+f,null,f),a.contextName=h.contextName,w(a);i&&v(l,function(a){F(a,{},{})});if((!c||b)&&e)if((z||ea)&&!X)X=setTimeout(function(){X=0;D()},50);W=!1}}function E(a){t(q,a[0])||r(i(a[0],null,!0)).init(a[1],a[2])}function I(a){var a=a.currentTarget||a.srcElement,b=h.onScriptLoad;a.detachEvent&&!Y?a.detachEvent("onreadystatechange",b):a.removeEventListener("load",b,!1);b=h.onScriptError;(!a.detachEvent||Y)&&a.removeEventListener("error",b,!1);return{node:a,id:a&&a.getAttribute("data-requiremodule")}}
function J(){var a;for(x();C.length;){a=C.shift();if(null===a[0])return w(B("mismatch","Mismatched anonymous define() module: "+a[a.length-1]));E(a)}h.defQueueMap={}}var W,Z,h,L,X,k={waitSeconds:7,baseUrl:"./",paths:{},bundles:{},pkgs:{},shim:{},config:{}},m={},V={},$={},C=[],q={},S={},aa={},K=1,O=1;L={require:function(a){return a.require?a.require:a.require=h.makeRequire(a.map)},exports:function(a){a.usingExports=!0;if(a.map.isDefine)return a.exports?q[a.map.id]=a.exports:a.exports=q[a.map.id]={}},
module:function(a){return a.module?a.module:a.module={id:a.map.id,uri:a.map.url,config:function(){return n(k.config,a.map.id)||{}},exports:a.exports||(a.exports={})}}};Z=function(a){this.events=n($,a.id)||{};this.map=a;this.shim=n(k.shim,a.id);this.depExports=[];this.depMaps=[];this.depMatched=[];this.pluginMaps={};this.depCount=0};Z.prototype={init:function(a,b,c,f){f=f||{};if(!this.inited){this.factory=b;if(c)this.on("error",c);else this.events.error&&(c=u(this,function(a){this.emit("error",a)}));
this.depMaps=a&&a.slice(0);this.errback=c;this.inited=!0;this.ignore=f.ignore;f.enabled||this.enabled?this.enable():this.check()}},defineDep:function(a,b){this.depMatched[a]||(this.depMatched[a]=!0,this.depCount-=1,this.depExports[a]=b)},fetch:function(){if(!this.fetched){this.fetched=!0;h.startTime=(new Date).getTime();var a=this.map;if(this.shim)h.makeRequire(this.map,{enableBuildCallback:!0})(this.shim.deps||[],u(this,function(){return a.prefix?this.callPlugin():this.load()}));else return a.prefix?
this.callPlugin():this.load()}},load:function(){var a=this.map.url;S[a]||(S[a]=!0,h.load(this.map.id,a))},check:function(){if(this.enabled&&!this.enabling){var a,b,c=this.map.id;b=this.depExports;var f=this.exports,l=this.factory;if(this.inited)if(this.error)this.emit("error",this.error);else{if(!this.defining){this.defining=!0;if(1>this.depCount&&!this.defined){if(G(l)){if(this.events.error&&this.map.isDefine||e.onError!==ca)try{f=h.execCb(c,l,b,f)}catch(d){a=d}else f=h.execCb(c,l,b,f);this.map.isDefine&&
void 0===f&&((b=this.module)?f=b.exports:this.usingExports&&(f=this.exports));if(a)return a.requireMap=this.map,a.requireModules=this.map.isDefine?[this.map.id]:null,a.requireType=this.map.isDefine?"define":"require",w(this.error=a)}else f=l;this.exports=f;if(this.map.isDefine&&!this.ignore&&(q[c]=f,e.onResourceLoad))e.onResourceLoad(h,this.map,this.depMaps);y(c);this.defined=!0}this.defining=!1;this.defined&&!this.defineEmitted&&(this.defineEmitted=!0,this.emit("defined",this.exports),this.defineEmitComplete=
!0)}}else t(h.defQueueMap,c)||this.fetch()}},callPlugin:function(){var a=this.map,b=a.id,d=i(a.prefix);this.depMaps.push(d);s(d,"defined",u(this,function(f){var l,d;d=n(aa,this.map.id);var g=this.map.name,P=this.map.parentMap?this.map.parentMap.name:null,p=h.makeRequire(a.parentMap,{enableBuildCallback:!0});if(this.map.unnormalized){if(f.normalize&&(g=f.normalize(g,function(a){return c(a,P,!0)})||""),f=i(a.prefix+"!"+g,this.map.parentMap),s(f,"defined",u(this,function(a){this.init([],function(){return a},
null,{enabled:!0,ignore:!0})})),d=n(m,f.id)){this.depMaps.push(f);if(this.events.error)d.on("error",u(this,function(a){this.emit("error",a)}));d.enable()}}else d?(this.map.url=h.nameToUrl(d),this.load()):(l=u(this,function(a){this.init([],function(){return a},null,{enabled:!0})}),l.error=u(this,function(a){this.inited=!0;this.error=a;a.requireModules=[b];A(m,function(a){0===a.map.id.indexOf(b+"_unnormalized")&&y(a.map.id)});w(a)}),l.fromText=u(this,function(f,c){var d=a.name,g=i(d),P=M;c&&(f=c);P&&
(M=!1);r(g);t(k.config,b)&&(k.config[d]=k.config[b]);try{e.exec(f)}catch(m){return w(B("fromtexteval","fromText eval for "+b+" failed: "+m,m,[b]))}P&&(M=!0);this.depMaps.push(g);h.completeLoad(d);p([d],l)}),f.load(a.name,p,l,k))}));h.enable(d,this);this.pluginMaps[d.id]=d},enable:function(){V[this.map.id]=this;this.enabling=this.enabled=!0;v(this.depMaps,u(this,function(a,b){var c,f;if("string"===typeof a){a=i(a,this.map.isDefine?this.map:this.map.parentMap,!1,!this.skipMap);this.depMaps[b]=a;if(c=
n(L,a.id)){this.depExports[b]=c(this);return}this.depCount+=1;s(a,"defined",u(this,function(a){this.undefed||(this.defineDep(b,a),this.check())}));this.errback?s(a,"error",u(this,this.errback)):this.events.error&&s(a,"error",u(this,function(a){this.emit("error",a)}))}c=a.id;f=m[c];!t(L,c)&&(f&&!f.enabled)&&h.enable(a,this)}));A(this.pluginMaps,u(this,function(a){var b=n(m,a.id);b&&!b.enabled&&h.enable(a,this)}));this.enabling=!1;this.check()},on:function(a,b){var c=this.events[a];c||(c=this.events[a]=
[]);c.push(b)},emit:function(a,b){v(this.events[a],function(a){a(b)});"error"===a&&delete this.events[a]}};h={config:k,contextName:b,registry:m,defined:q,urlFetched:S,defQueue:C,defQueueMap:{},Module:Z,makeModuleMap:i,nextTick:e.nextTick,onError:w,configure:function(a){a.baseUrl&&"/"!==a.baseUrl.charAt(a.baseUrl.length-1)&&(a.baseUrl+="/");var b=k.shim,c={paths:!0,bundles:!0,config:!0,map:!0};A(a,function(a,b){c[b]?(k[b]||(k[b]={}),U(k[b],a,!0,!0)):k[b]=a});a.bundles&&A(a.bundles,function(a,b){v(a,
function(a){a!==b&&(aa[a]=b)})});a.shim&&(A(a.shim,function(a,c){H(a)&&(a={deps:a});if((a.exports||a.init)&&!a.exportsFn)a.exportsFn=h.makeShimExports(a);b[c]=a}),k.shim=b);a.packages&&v(a.packages,function(a){var b,a="string"===typeof a?{name:a}:a;b=a.name;a.location&&(k.paths[b]=a.location);k.pkgs[b]=a.name+"/"+(a.main||"main").replace(ha,"").replace(Q,"")});A(m,function(a,b){!a.inited&&!a.map.unnormalized&&(a.map=i(b,null,!0))});if(a.deps||a.callback)h.require(a.deps||[],a.callback)},makeShimExports:function(a){return function(){var b;
a.init&&(b=a.init.apply(ba,arguments));return b||a.exports&&da(a.exports)}},makeRequire:function(a,j){function g(c,d,p){var k,n;j.enableBuildCallback&&(d&&G(d))&&(d.__requireJsBuild=!0);if("string"===typeof c){if(G(d))return w(B("requireargs","Invalid require call"),p);if(a&&t(L,c))return L[c](m[a.id]);if(e.get)return e.get(h,c,a,g);k=i(c,a,!1,!0);k=k.id;return!t(q,k)?w(B("notloaded",'Module name "'+k+'" has not been loaded yet for context: '+b+(a?"":". Use require([])"))):q[k]}J();h.nextTick(function(){J();
n=r(i(null,a));n.skipMap=j.skipMap;n.init(c,d,p,{enabled:!0});D()});return g}j=j||{};U(g,{isBrowser:z,toUrl:function(b){var d,e=b.lastIndexOf("."),j=b.split("/")[0];if(-1!==e&&(!("."===j||".."===j)||1<e))d=b.substring(e,b.length),b=b.substring(0,e);return h.nameToUrl(c(b,a&&a.id,!0),d,!0)},defined:function(b){return t(q,i(b,a,!1,!0).id)},specified:function(b){b=i(b,a,!1,!0).id;return t(q,b)||t(m,b)}});a||(g.undef=function(b){x();var c=i(b,a,!0),e=n(m,b);e.undefed=!0;d(b);delete q[b];delete S[c.url];
delete $[b];T(C,function(a,c){a[0]===b&&C.splice(c,1)});delete h.defQueueMap[b];e&&(e.events.defined&&($[b]=e.events),y(b))});return g},enable:function(a){n(m,a.id)&&r(a).enable()},completeLoad:function(a){var b,c,d=n(k.shim,a)||{},e=d.exports;for(x();C.length;){c=C.shift();if(null===c[0]){c[0]=a;if(b)break;b=!0}else c[0]===a&&(b=!0);E(c)}h.defQueueMap={};c=n(m,a);if(!b&&!t(q,a)&&c&&!c.inited){if(k.enforceDefine&&(!e||!da(e)))return p(a)?void 0:w(B("nodefine","No define call for "+a,null,[a]));E([a,
d.deps||[],d.exportsFn])}D()},nameToUrl:function(a,b,c){var d,g,i;(d=n(k.pkgs,a))&&(a=d);if(d=n(aa,a))return h.nameToUrl(d,b,c);if(e.jsExtRegExp.test(a))d=a+(b||"");else{d=k.paths;a=a.split("/");for(g=a.length;0<g;g-=1)if(i=a.slice(0,g).join("/"),i=n(d,i)){H(i)&&(i=i[0]);a.splice(0,g,i);break}d=a.join("/");d+=b||(/^data\:|\?/.test(d)||c?"":".js");d=("/"===d.charAt(0)||d.match(/^[\w\+\.\-]+:/)?"":k.baseUrl)+d}return k.urlArgs?d+((-1===d.indexOf("?")?"?":"&")+k.urlArgs):d},load:function(a,b){e.load(h,
a,b)},execCb:function(a,b,c,d){return b.apply(d,c)},onScriptLoad:function(a){if("load"===a.type||ia.test((a.currentTarget||a.srcElement).readyState))N=null,a=I(a),h.completeLoad(a.id)},onScriptError:function(a){var b=I(a);if(!p(b.id))return w(B("scripterror","Script error for: "+b.id,a,[b.id]))}};h.require=h.makeRequire();return h}var e,x,y,D,I,E,N,J,r,O,ja=/(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/mg,ka=/[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,Q=/\.js$/,ha=/^\.\//;x=Object.prototype;var K=
x.toString,fa=x.hasOwnProperty,z=!!("undefined"!==typeof window&&"undefined"!==typeof navigator&&window.document),ea=!z&&"undefined"!==typeof importScripts,ia=z&&"PLAYSTATION 3"===navigator.platform?/^complete$/:/^(complete|loaded)$/,Y="undefined"!==typeof opera&&"[object Opera]"===opera.toString(),F={},s={},R=[],M=!1;if("undefined"===typeof define){if("undefined"!==typeof requirejs){if(G(requirejs))return;s=requirejs;requirejs=void 0}"undefined"!==typeof require&&!G(require)&&(s=require,require=
void 0);e=requirejs=function(b,c,d,p){var g,i="_";!H(b)&&"string"!==typeof b&&(g=b,H(c)?(b=c,c=d,d=p):b=[]);g&&g.context&&(i=g.context);(p=n(F,i))||(p=F[i]=e.s.newContext(i));g&&p.configure(g);return p.require(b,c,d)};e.config=function(b){return e(b)};e.nextTick="undefined"!==typeof setTimeout?function(b){setTimeout(b,4)}:function(b){b()};require||(require=e);e.version="2.1.20";e.jsExtRegExp=/^\/|:|\?|\.js$/;e.isBrowser=z;x=e.s={contexts:F,newContext:ga};e({});v(["toUrl","undef","defined","specified"],
function(b){e[b]=function(){var c=F._;return c.require[b].apply(c,arguments)}});if(z&&(y=x.head=document.getElementsByTagName("head")[0],D=document.getElementsByTagName("base")[0]))y=x.head=D.parentNode;e.onError=ca;e.createNode=function(b){var c=b.xhtml?document.createElementNS("http://www.w3.org/1999/xhtml","html:script"):document.createElement("script");c.type=b.scriptType||"text/javascript";c.charset="utf-8";c.async=!0;return c};e.load=function(b,c,d){var p=b&&b.config||{},g;if(z){g=e.createNode(p,
c,d);if(p.onNodeCreated)p.onNodeCreated(g,p,c,d);g.setAttribute("data-requirecontext",b.contextName);g.setAttribute("data-requiremodule",c);g.attachEvent&&!(g.attachEvent.toString&&0>g.attachEvent.toString().indexOf("[native code"))&&!Y?(M=!0,g.attachEvent("onreadystatechange",b.onScriptLoad)):(g.addEventListener("load",b.onScriptLoad,!1),g.addEventListener("error",b.onScriptError,!1));g.src=d;J=g;D?y.insertBefore(g,D):y.appendChild(g);J=null;return g}if(ea)try{importScripts(d),b.completeLoad(c)}catch(i){b.onError(B("importscripts",
"importScripts failed for "+c+" at "+d,i,[c]))}};z&&!s.skipDataMain&&T(document.getElementsByTagName("script"),function(b){y||(y=b.parentNode);if(I=b.getAttribute("data-main"))return r=I,s.baseUrl||(E=r.split("/"),r=E.pop(),O=E.length?E.join("/")+"/":"./",s.baseUrl=O),r=r.replace(Q,""),e.jsExtRegExp.test(r)&&(r=I),s.deps=s.deps?s.deps.concat(r):[r],!0});define=function(b,c,d){var e,g;"string"!==typeof b&&(d=c,c=b,b=null);H(c)||(d=c,c=null);!c&&G(d)&&(c=[],d.length&&(d.toString().replace(ja,"").replace(ka,
function(b,d){c.push(d)}),c=(1===d.length?["require"]:["require","exports","module"]).concat(c)));if(M){if(!(e=J))N&&"interactive"===N.readyState||T(document.getElementsByTagName("script"),function(b){if("interactive"===b.readyState)return N=b}),e=N;e&&(b||(b=e.getAttribute("data-requiremodule")),g=F[e.getAttribute("data-requirecontext")])}g?(g.defQueue.push([b,c,d]),g.defQueueMap[b]=!0):R.push([b,c,d])};define.amd={jQuery:!0};e.exec=function(b){return eval(b)};e(s)}})(this);

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer', ['ngAnimate', 'restangular', 'ui.router', 'ngMaterial', 'toastr',
      'ngCookies', 'pascalprecht.translate', 'tmh.dynamicLocale', 'ngMaterialDatePicker', 'dx','nvd3']);

})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('rwLeftNav', rwLeftNavDir);

  /** @ngInject */
  function rwLeftNavDir() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/directive/navs/leftnav/left_nav.tpl.html',
      controller: RwLeftNavDirController,
      controllerAs: 'vm',
      bindToController: {
        resetCamera: '&',
        zoomInCamera: '&',
        zoomOutCamera: '&',
        locationOn: '&'

      },
      scope:{
        locationShow: '='
      }
    };

    return directive;
  }

  /** @ngInject */
  function RwLeftNavDirController($scope, $mdSidenav, $log) {
    var vm = this;
    if ($scope.locationShow === undefined)
      $scope.locationShow = true;
    $scope.$watch('locationShow', function(newDir, oldDir) {
     // $scope.locationShow = newDir;
    });
    $scope.autorenew = function () {
      vm.resetCamera();
    };

    $scope.location_on = function () {
      vm.locationOn();
    };
    $scope.zoom_in = function () {
      vm.zoomInCamera();
    };

    $scope.zoom_out = function () {
      vm.zoomOutCamera();
    }
    // $mdSidenav('left').onClose(function(){
    //   console.log('closed!');
    // });
    // $scope.open=function(){
    //   $mdSidenav('left')
    //     .toggle()
    //     .then(function () {
    //       document.body.lastChild.previousElementSibling.previousElementSibling.style.zIndex=-100000;
    //       $log.debug("left nav is done");
    //     });
    // };
    // $scope.close = function () {
    //   // Component lookup should always be available since we are not using `ng-if`
    //   $mdSidenav('left').close()
    //     .then(function () {
    //       document.body.lastChild.previousElementSibling.previousElementSibling.style.zIndex=100000;
    //       $log.debug("close left is done");
    //     });
    // };

  }

})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('adminLeftNav', adminLeftNavDir);

  /** @ngInject */
  function adminLeftNavDir() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/admin/directive/navs/leftnav/left_nav.tpl.html',
      controller: AdminLeftNavDirController,
      controllerAs: 'vm',
      bindToController: {
        rwSelected: '='
      },
    };

    return directive;
  }

  /** @ngInject */
  function AdminLeftNavDirController($scope, $mdSidenav, $log, coreService, $state,$timeout) {
    var vm = this;

    $scope.isOpen=false;
    $scope.openNav=function() {
      document.getElementById("mySidenav").style.width = "250px";
      document.getElementById("main").style.marginLeft = "200px";
      $scope.isOpen=true;
    };

    $scope.closeNav=function() {
      document.getElementById("mySidenav").style.width = "0";
      document.getElementById("main").style.marginLeft= "0";
      $scope.isOpen=false;
    };


    $scope.sLink=function(index){
      switch (index) {
        case 0:
          $state.go('ad_main');
          break;
        case 1:
          $state.go('admin-complaints');
          break;
        case 2:
          $state.go('admin-complaint-waiting');
          break;
        case 3:
          $state.go('admin-complaints-filter');
          break;
        case 4:
          $state.go('admin-complaints-statistic');
          break;
        default:
          $state.go('admin-login');
          break;
      }
    };
    $scope.sDisabled = function (index) {
      return vm.rwSelected === index;
    };

    $scope.logout = function () {
      coreService.logout_user();
      $state.go('admin-login')
    };
    $scope.username="";
    $timeout(function () {
      if (!coreService.is_logged_in()) {
        debugger;
        $state.go('admin-login');
        return;
      }
      $scope.username = coreService.get_user()['username'];
    }, 200);


  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('AdminComplaintStatisticController', AdminComplaintStatisticController);


  /** @ngInject */
  function AdminComplaintStatisticController($scope, $q, $rootScope, bimServerService, $filter) {
    var vm = this;

    $scope.onDateChange1 = function (cbState) {
      $scope.refreshChart1Data();
    };

    $scope.refreshChart1Data = function () {
      var data = $filter('filter')($scope.grid_datas, function (a) {
        var t = moment(a.creationTime, 'YYYY-MM-DD HH:mm');
        return t >= moment($scope.startDate1) && t <= moment($scope.endDate1)
      });
      vm.getChartData1(data);
    };

    $scope.chartOptions1 = {
      bindingOptions: {
        dataSource: {
          <!-- Enables deep tracking of changes -->
          deep: true,
          <!-- Specifies which scope property to track changes in -->
          dataPath: 'chart_data'
        }
      },
      screenByWidth: function (width) {
        return (width < 700) ? 'sm' : 'lg';
      },
      commonSeriesSettings: {
        argumentField: "state",
        type: "stackedBar"
      },
      onPointClick: function (e) {
        e.target.select();
      },
      onLegendClick: function (e) {
        var series = e.target;
        if (series.isVisible()) {
          series.hide();
        } else {
          series.show();
        }
      },
      series: [
        // {valueField: "approved", name: $filter('translate')('chart_status_approved')},
        // {valueField: "waiting", name: $filter('translate')('chart_status_waiting')},
        // {valueField: "rejected", name: $filter('translate')('chart_status_rejected')},
        // {valueField: "terminated", name: $filter('translate')('chart_status_terminated')},
        {valueField: "approved", name: "Onaylandı"},
        {valueField: "waiting", name: "Beklemede"},
        {valueField: "rejected", name: "Reddedildi"},
        {valueField: "terminated", name: "Sonlandırıldı"}
      ],
      legend: {
        verticalAlignment: "bottom",
        horizontalAlignment: "center",
        itemTextPosition: 'top'
      },
      valueAxis: {
        title: {
          text: "adet"
        },
        position: "right"
      },
      title: "Günlere Göre Şikayetler",
      "export": {
        enabled: true
      },
      tooltip: {
        enabled: true,
        location: "edge",
        customizeTooltip: function (arg) {
          return {
            text: arg.seriesName + " : " + arg.valueText
          };
        }
      }
    };

    vm.getChartData1 = function (data) {
      $scope.chart_data = _.map(_.groupBy(data, 'date'), function (y, j) {
        return {
          state: j,
          approved: Math.trunc($filter('filter')(y, function (a) {
            return a.status === 'approved'
          }).length),
          waiting: Math.trunc($filter('filter')(y, function (a) {
            return a.status === 'waiting'
          }).length),
          rejected: Math.trunc($filter('filter')(y, function (a) {
            return a.status === 'rejected'
          }).length),
          terminated: Math.trunc($filter('filter')(y, function (a) {
            return a.status === 'terminated'
          }).length)
        }
      })
    };

    vm.getChartData2 = function (data) {
      $scope.chart_data2 = _.map(_.groupBy(data, 'dimension'), function (y, j) {
        return {
          complaintType: $filter('translate')(j),
          complaintCount: y.length
        }
      })
    };
    $scope.chartOptions2 = {
      bindingOptions: {
        dataSource: {
          <!-- Enables deep tracking of changes -->
          deep: true,
          <!-- Specifies which scope property to track changes in -->
          dataPath: 'chart_data2'
        }
      },
      screenByWidth: function (width) {
        return (width < 700) ? 'sm' : 'lg';
      },
      onPointClick: function (e) {
        e.target.select();
      },
      onLegendClick: function (e) {
        var points = e.points;
        points[0].isVisible() ? points[0].hide() : points[0].show();
      },
      series: [
        {
          argumentField: "complaintType",
          valueField: "complaintCount",
          label: {
            visible: true,
            connector: {
              visible: true,
              width: 1
            },
            customizeText: function(arg) {
              return arg.argumentText+" : "+ arg.valueText + " (" + arg.percentText + ")";
            }
          }
        }
      ],
      legend: {
        verticalAlignment: "bottom",
        horizontalAlignment: "center",
        itemTextPosition: 'top'
      },
      title: "Türlerine Göre Şikayetler",
      "export": {
        enabled: true
      }
    };
    $scope.onDateChange2 = function (cbState) {
      $scope.refreshChart2Data();
    };

    $scope.refreshChart2Data = function () {
      var data = $filter('filter')($scope.grid_datas, function (a) {
        var t = moment(a.creationTime, 'YYYY-MM-DD HH:mm');
        return t >= moment($scope.startDate2) && t <= moment($scope.endDate2)
      });
      vm.getChartData2(data);
    };


    $scope.bimModelOptions = {};
    $scope.grid_datas = [];
    $scope.grid_columns = [];
    $scope.getDatas = function () {
      bimServerService.getComplaints().then(function (data) {
        $scope.grid_datas = data.result;
        vm.getChartData1(data.result);
        vm.getChartData2(data.result);
      });
    };
    $scope.getDatas();
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('AdminComplaintWaitingController', AdminComplaintWaitingController);

  /** @ngInject */
  function AdminComplaintWaitingController($scope, $rootScope, coreService, utilsService, $log, $filter, toastr, $window, bimServerService,$interval) {
    var vm = this;
    $scope.bimModelOptions = {};
    $scope.grid_datas = [];
    $scope.getDatas = function () {
      bimServerService.getOpenComplaints().then(function (data) {
        $scope.grid_datas = data.result;
      });
    };
    $scope.selectedComplaint = null;

    $scope.initGrid = function () {
      $scope.gridOptions = {
        showBorders: true,
        showRowLines: true,
        rowAlternationEnabled: true,
        allowColumnResizing: true,
        columnAutoWidth: true,
        filterRow: {visible: true},
        filterPanel: {visible: true},
        headerFilter: {visible: true},
        paging: {
          pageSize: 5
        },
        columnChooser: {
          enabled: true,
          mode: "select"
        },
        export: {
          enabled: true,
          fileName: "Complaints",
          allowExportSelectedData: true
        },
        onExporting: function (e) {
          if (angular.isDefined($scope.export_stop) ){
            e.cancel=true;
          }
          // Handler of the "exporting" event
          $scope.export_stop = $interval(function() {
            $interval.cancel($scope.export_stop);
            $scope.export_stop=undefined;
          },1000);
        },
        selection: {
          mode: "multiple"
        },
        bindingOptions: {
          dataSource: {
            <!-- Enables deep tracking of changes -->
            deep: false,
            <!-- Specifies which scope property to track changes in -->
            dataPath: 'grid_datas'
          }
        },
        columns: [{
          caption: 'buttons',
          type: 'buttons',
          width: 230,
          allowHiding: false,
          showInColumnChooser: false,
          buttons: [
            {
              hint: "Modelde Göster",
              icon: "search",
              onClick: function (e) {
                var id = e.row.data.index;
                $scope.selectedComplaint = _.first(_.filter($scope.grid_datas, ['index', id]));
                if (angular.isDefined($scope.bimModelOptions.viewComplaint))
                  $scope.bimModelOptions.viewComplaint($scope.selectedComplaint);
              }
            }
          ]
        },
          {
            dataField: "index",
            headerFilter: {allowSearch: true},
            dataType: 'Number',
            caption: "Şikayet No"
          },
          {
            dataField: "indicator",
            caption: "Şikayet",
            headerFilter: {allowSearch: true},
            calculateCellValue: function (data) {
              return $filter('translate')(data.indicator);
            }
          },
          {
            dataField: "user.username",
            headerFilter: {allowSearch: true},
            caption: "Kullanıcı Adı"
          },
        ]
      };
      $scope.getDatas();
    };
    $scope.initGrid();
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('AdminComplaintFilterListController', AdminComplaintFilterListController);


  /** @ngInject */
  function AdminComplaintFilterListController($scope, $q, $rootScope, $document, coreService, utilsService, $log, $filter, toastr, $window, bimServerService, $interval) {
    var vm = this;
    $scope.eDisabled = function (type) {
      return $scope.selected_type === type;
    };
    $scope.tabClick = function (val) {
      $scope.selected_type = val;
    };
    $scope.selected_type = 1;
    $scope.bimLoaded = function () {
      // $window.bimSurfer.setVisibility({types: ["IfcSpace"], visible: true });
      // $window.bimSurfer.setOpacity({types: ["IfcSpace"], opacity: 0.5 });
      $window.bimSurfer.setLights([{
        type: "dir",
        params: {
          dir: [0.0, 0.0, -1.0],
          color: [0.0, .4, .4],
          intensity: 1,
          space: "view"
        }
      }, {
        type: "ambient",
        params: {
          color: [0.65, 0.65, 0.75],
          intensity: 0.5
        }
      }])
    };
    // if (angular.isDefined($window.bimSurfer))
    //   $window.bimSurfer.setVisibility({types: ["IfcSpace"], visible: true });

    $scope.onChange = function (val) {
      if (val === 0) {
        $scope.bimModelOptions.view($scope.selectedComplaint, 'sor');
      } else
        $scope.bimModelOptions.view($scope.selectedComplaint, 'loc');
      $scope.selected_type = val;
      $scope.changeColors();
    };

    $scope.changeColors = function () {
      bimSurfer.resetColor();
      var data = $scope.grid_datas_filtered;
      bimSurfer.setVisibility({types: ["IfcSpace"], visible: false});
      if (angular.isUndefined(data) || data == null) return;
      if (data.length > 0) {
        var user = coreService.get_user();
        var grp_datas = _.countBy(data, 'location.guid');
        if ($scope.selected_type === 0) {
          grp_datas = _.countBy(data, 'source.guid');
        }
        var grp_keys = Object.keys(grp_datas);
        for (var i = 0; i < grp_keys.length; i++) {
          var guid = grp_keys[i];
          var val = grp_datas[grp_keys[i]];
          var id = bimSurfer.toId([guid]);
          if (angular.isDefined(id) && id !== '' && id.length > 0 && id[0] !== null) {
            bimSurfer.setColor({ids: [user['roid'] + ":" + id], colorType: val});
            bimSurfer.setVisibility({ids: [user['roid'] + ":" + id], visible: true});
          }
        }
      } else {

      }

    };
    // GridList Configurations
    $scope.bimModelOptions = {};
    $scope.selectedComplaint = null;
    $scope.selected_grid_id = -1;

    $scope.grid_datas = [];
    $scope.grid_datas_filtered = [];
    $scope.grid_columns = [];
    $scope.getDatas = function () {

      bimServerService.getComplaints().then(function (data) {
        /*
        if (angular.isDefined(data.location)&&data.location!='')
          return bimServerService.str('loc',data.location);
        return "";
        * */
        var locations = [];
        var sources = [];
        for (var i = 0; i < data.result.length; i++) {
          locations.push(bimServerService.str2('loc', data.result[i].location));
          sources.push(bimServerService.str2('loc', data.result[i].source));
        }
        $q.all(locations).then(function (arrays) {
          for (var i = 0; i < data.result.length; i++) {
            data.result[i].locationName = arrays[i];
          }
        }).then(function () {
          $q.all(sources).then(function (arrays) {
            for (var i = 0; i < data.result.length; i++) {
              data.result[i].sourceName = arrays[i];
            }
          }).then(function () {
            $scope.grid_datas = data.result
          });
        });
      });
    };
    $scope.dataGrid = null;
    $scope.dataGrid_filtered = null;
    $scope.initGrid = function () {
      $scope.gridOptions = {
        showBorders: true,
        showRowLines: true,
        rowAlternationEnabled: true,
        allowColumnResizing: true,
        columnAutoWidth: true,
        filterRow: {visible: true},
        filterPanel: {visible: true},
        headerFilter: {visible: true},
        paging: {
          pageSize: 20
        },
        onInitialized: function (e) {
          $scope.dataGrid = e.component;
        },
        onSelectionChanged: function (selectedItems) {
          var data = selectedItems.selectedRowsData;
          bimSurfer.resetColor();
          if (data.length > 0) {

            $scope.grid_datas_filtered = data;
            $scope.changeColors();
          } else {
            $scope.grid_datas_filtered = [];
          }

        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [5, 10, 20],
          showInfo: true
        },
        columnChooser: {
          enabled: true,
          mode: "select"
        },
        export: {
          enabled: true,
          fileName: "Complaints",
          allowExportSelectedData: true
        },
        onExporting: function (e) {
          if (angular.isDefined($scope.export_stop)) {
            e.cancel = true;
          }
          // Handler of the "exporting" event
          $scope.export_stop = $interval(function () {
            $interval.cancel($scope.export_stop);
            $scope.export_stop = undefined;
          }, 1000);
        },
        selection: {
          mode: "multiple"
        },
        bindingOptions: {
          dataSource: {
            <!-- Enables deep tracking of changes -->
            deep: true,
            <!-- Specifies which scope property to track changes in -->
            dataPath: 'grid_datas'
          }
        },
        columns: [
          {
            dataField: "index",
            headerFilter: {allowSearch: true},
            dataType: 'Number',
            caption: "Şikayet No"
          },
          {
            dataField: "dimension",
            caption: "Şikayet Grubu",
            headerFilter: {allowSearch: true},
            calculateCellValue: function (data) {
              return $filter('translate')(data.dimension);
            }
          },
          {
            dataField: "criteria",
            caption: "Şikayet Türü",
            headerFilter: {allowSearch: true},
            calculateCellValue: function (data) {
              return $filter('translate')(data.criteria);
            }
          },
          {
            dataField: "indicator",
            caption: "Şikayet",
            headerFilter: {allowSearch: true},
            calculateCellValue: function (data) {
              return $filter('translate')(data.indicator);
            }
          },
          {
            caption: "Konum",
            columns: [{
              caption: "IFC",
              dataField: "location",
              headerFilter: {allowSearch: true},
              calculateCellValue: function (data) {
                if (angular.isUndefined(data.location) || data.location === '' || data.location === null)
                  return '';
                if (angular.isUndefined(data.location.typeName) || data.location.typeName === '' || data.location.typeName === null)
                  return data.location.guid;
                return data.location.typeName + ' ' + data.location.guid
              }
            }, {
              caption: "TR",
              dataField: "locationName",
              headerFilter: {allowSearch: true},
            }]
          },
          {
            caption: "Kaynak",
            columns: [{
              caption: "IFC",
              dataField: "source",
              headerFilter: {allowSearch: true},
              calculateCellValue: function (data) {
                if (angular.isUndefined(data.source) || data.source === '' || data.source === null)
                  return '';
                if (angular.isUndefined(data.source.typeName) || data.source.typeName === '' || data.source.typeName === null)
                  return data.source.guid;
                return data.source.typeName + ' ' + data.source.guid
              }
            }, {
              caption: "TR",
              dataField: "sourceName",
              headerFilter: {allowSearch: true},
            }]
          },
          {
            caption: 'Eleman Türü',
            headerFilter: {allowSearch: true},
            dataField: 'asdasd',
            calculateCellValue: function (data) {
              if (angular.isDefined(data.source.typeName) && data.source.typeName !== '') {
                switch (data.source.typeName) {
                  case 'IfcCovering':
                  case 'IfcCurtainWall':
                  case 'IfcPlate':
                  case 'IfcDoor':
                    return 'Mimari';
                  case 'IfcFlowTerminal':
                    if (angular.isDefined(data.sourceName))
                      if (_.includes(data.sourceName.toLowerCase(), 'aydınlatma'))
                        return 'Elektrik';
                    return 'Mekanik';
                  case 'IfcFurnishingElement':
                    return 'Mobilya';
                  default:
                    break;
                }
                return 'Diğer';
              }
              if (angular.isDefined(data.sourceName)) {
                if (_.includes(data.sourceName.toLowerCase(), 'pencere'))
                  return 'Mimari';
                if (_.includes(data.sourceName.toLowerCase(), 'kapı'))
                  return 'Mimari';
              }
              if (angular.isDefined(data.source) && data.source !== '') {
                return 'Diğer';
              }
            }
          },
          {
            caption: "Zaman",
            dataField: "time",
            dataType: "datetime",
            width: 180,
            format: "yyyy-MM-dd HH:mm",
            calculateCellValue: function (data) {
              if (angular.isUndefined(data.time) || data.time === '' || data.time === null)
                return moment(data.creationTime, 'YYYY-MM-DD HH:mm').startOf('day').add(7, 'days').format('YYYY-MM-DD HH:mm');
              return data.time;
            }
          },
          {
            caption: 'Müdahale Zamanı',
            dataField: 'response_time',
            dataType: "datetime",
            width: 180,
            format: "yyyy-MM-dd HH:mm",
            calculateCellValue: function (data) {
              if (angular.isUndefined(data.response_time) || data.response_time === '' || data.response_time === null)
                if (angular.isUndefined(data.time) || data.time === '' || data.time === null)
                  return moment(data.creationTime, 'YYYY-MM-DD HH:mm').startOf('day').add(7, 'days').format('YYYY-MM-DD HH:mm');
                else
                  return moment(data.time, 'YYYY-MM-DD HH:mm').startOf('day').add(7, 'days').format('YYYY-MM-DD HH:mm');
              return data.response_time;
            }
          },
          {
            dataField: 'message',
            caption: 'Ek Bilgi'
          },
          {
            dataField: 'fm_message',
            caption: 'FM Ek Bilgi'
          },
          {
            dataField: 'fm_technician',
            caption: 'Atanan Teknisyen'
          },
          {
            dataField: 'status',
            caption: 'Durumu',
            calculateCellValue: function (data) {
              return $filter('translate')('chart_status_' + data.status);
            }
          },
          {
            dataField: "user.username",
            headerFilter: {allowSearch: true},
            caption: "Kullanıcı Adı"
          },
        ]
      };
      $scope.gridOptions_filtered = {
        showBorders: true,
        showRowLines: true,
        rowAlternationEnabled: true,
        allowColumnResizing: true,
        columnAutoWidth: true,
        onInitialized: function (e) {
          $scope.dataGrid_filtered = e.component;
        },
        bindingOptions: {
          dataSource: {
            <!-- Enables deep tracking of changes -->
            deep: true,
            <!-- Specifies which scope property to track changes in -->
            dataPath: 'grid_datas_filtered'
          }
        },
        columns: [{
          caption: 'buttons',
          type: 'buttons',
          width: 50,
          allowHiding: false,
          showInColumnChooser: false,
          buttons: [
            {
              hint: "Modelde Göster",
              icon: "search",
              onClick: function (e) {
                var id = e.row.data.index;
                $scope.selectedComplaint = _.first(_.filter($scope.grid_datas_filtered, ['index', id]));
                if (angular.isDefined($scope.bimModelOptions.viewComplaint)) {
                  if ($scope.selected_type === 0) {
                    $scope.bimModelOptions.view($scope.selectedComplaint, 'sor');
                  } else
                    $scope.bimModelOptions.view($scope.selectedComplaint, 'loc');
                }
              }
            }
          ]
        },
          {
            dataField: "index",
            dataType: 'Number',
            caption: "Şikayet No"
          },
          {
            dataField: "indicator",
            caption: "Şikayet",
            headerFilter: {allowSearch: true},
            calculateCellValue: function (data) {
              return $filter('translate')(data.indicator);
            }
          },
          {
            dataField: 'status',
            caption: 'Durumu',
            calculateCellValue: function (data) {
              return $filter('translate')('chart_status_' + data.status);
            }
          }
        ]
      };
      $scope.getDatas();
    };
    if (angular.isDefined($window.bimSurfer) && $window.bimSurfer != null)
      $scope.initGrid();
    else
      $rootScope.$on('bimSurferLoaded', function () {
        $scope.enableCanvas();
        $scope.initGrid();
      });
    $scope.selectedTab = 1;
    $scope.tabClick = function (index) {
      if (index === 1) {
        $scope.selectedTab = 1;
        $scope.enableCanvas();
      } else {
        $scope.selectedTab = 2;
        $scope.enableCanvas();
      }
    };

    $scope.enableCanvas = function () {
      switch ($scope.selectedTab) {
        case 1:
          if ($document[0].getElementById('xeoglShadowDiv') != null)
            $document[0].getElementById('xeoglShadowDiv').style["visibility"] = "hidden";
          break;
        case 2:
          if ($document[0].getElementById('xeoglShadowDiv') != null)
            $document[0].getElementById('xeoglShadowDiv').style["visibility"] = "visible";
          break
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('AdminComplaintListController', AdminComplaintListController);


  /** @ngInject */
  function AdminComplaintListController($scope, $q, $rootScope, coreService, utilsService, $log, $filter, toastr, $window, bimServerService, $interval) {
    var vm = this;
    // GridList Configurations
    $scope.bimModelOptions = {};
    $scope.selectedComplaint = null;
    $scope.selected_grid_id = -1;

    $scope.grid_datas = [];
    $scope.grid_columns = [];
    $scope.getDatas = function () {

      bimServerService.getComplaints().then(function (data) {
        /*
        if (angular.isDefined(data.location)&&data.location!='')
          return bimServerService.str('loc',data.location);
        return "";
        * */
        var locations = [];
        var sources = [];
        for (var i = 0; i < data.result.length; i++) {
          locations.push(bimServerService.str2('loc', data.result[i].location));
          sources.push(bimServerService.str2('loc', data.result[i].source));
        }
        $q.all(locations).then(function (arrays) {
          for (var i = 0; i < data.result.length; i++) {
            data.result[i].locationName = arrays[i];
          }
        }).then(function () {
          $q.all(sources).then(function (arrays) {
            for (var i = 0; i < data.result.length; i++) {
              data.result[i].sourceName = arrays[i];
            }
          }).then(function () {
            $scope.grid_datas = data.result
          });
        });
      });
    };
    $scope.initGrid = function () {
      $scope.gridOptions = {
        showBorders: true,
        showRowLines: true,
        rowAlternationEnabled: true,
        allowColumnResizing: true,
        columnAutoWidth: true,
        filterRow: {visible: true},
        filterPanel: {visible: true},
        headerFilter: {visible: true},
        paging: {
          pageSize: 5
        },
        columnChooser: {
          enabled: true,
          mode: "select"
        },
        export: {
          enabled: true,
          fileName: "Complaints",
          allowExportSelectedData: true
        },
        onExporting: function (e) {
          if (angular.isDefined($scope.export_stop)) {
            e.cancel = true;
          }
          // Handler of the "exporting" event
          $scope.export_stop = $interval(function () {
            $interval.cancel($scope.export_stop);
            $scope.export_stop = undefined;
          }, 1000);
        },
        selection: {
          mode: "multiple"
        },
        bindingOptions: {
          dataSource: {
            <!-- Enables deep tracking of changes -->
            // deep: true,
            <!-- Specifies which scope property to track changes in -->
            dataPath: 'grid_datas'
          }
        },
        columns: [
          {
            caption: 'buttons',
            type: 'buttons',
            width: 50,
            allowHiding: false,
            showInColumnChooser: false,
            buttons: [
              {
                hint: "Modelde Göster",
                icon: "search",
                onClick: function (e) {
                  var id = e.row.data.index;
                  $scope.selectedComplaint = _.first(_.filter($scope.grid_datas, ['index', id]));
                  if (angular.isDefined($scope.bimModelOptions.viewComplaint))
                    $scope.bimModelOptions.viewComplaint($scope.selectedComplaint);
                }
              }
            ]
          },
          {
            dataField: "index",
            headerFilter: {allowSearch: true},
            dataType: 'Number',
            caption: "Şikayet No"
          },
          {
            dataField: "dimension",
            caption: "Şikayet Grubu",
            headerFilter: {allowSearch: true},
            calculateCellValue: function (data) {
              return $filter('translate')(data.dimension);
            }
          },
          {
            dataField: "criteria",
            caption: "Şikayet Türü",
            headerFilter: {allowSearch: true},
            calculateCellValue: function (data) {
              return $filter('translate')(data.criteria);
            }
          },
          {
            dataField: "indicator",
            caption: "Şikayet",
            headerFilter: {allowSearch: true},
            calculateCellValue: function (data) {
              return $filter('translate')(data.indicator);
            }
          },
          {
            caption: "Konum",
            columns: [{
              caption: "IFC",
              dataField: "location",
              headerFilter: {allowSearch: true},
              calculateCellValue: function (data) {
                if (angular.isUndefined(data.location) || data.location === '' || data.location === null)
                  return '';
                if (angular.isUndefined(data.location.typeName) || data.location.typeName === '' || data.location.typeName === null)
                  return data.location.guid;
                return data.location.typeName + ' ' + data.location.guid
              }
            }, {
              caption: "TR",
              dataField: "locationName",
              headerFilter: {allowSearch: true},
            }]
          },
          {
            caption: "Kaynak",
            columns: [{
              caption: "IFC",
              dataField: "source",
              headerFilter: {allowSearch: true},
              calculateCellValue: function (data) {
                if (angular.isUndefined(data.source) || data.source === '' || data.source === null)
                  return '';
                if (angular.isUndefined(data.source.typeName) || data.source.typeName === '' || data.source.typeName === null)
                  return data.source.guid;
                return data.source.typeName + ' ' + data.source.guid
              }
            }, {
              caption: "TR",
              dataField: "sourceName",
              headerFilter: {allowSearch: true},
            }]
          },
          {
            caption: 'Eleman Türü',
            headerFilter: {allowSearch: true},
            dataField: 'asdasd',
            calculateCellValue: function (data) {
              if (angular.isDefined(data.source.typeName) && data.source.typeName !== '') {
                switch (data.source.typeName) {
                  case 'IfcCovering':
                  case 'IfcCurtainWall':
                  case 'IfcPlate':
                  case 'IfcDoor':
                    return 'Mimari';
                  case 'IfcFlowTerminal':
                    if (angular.isDefined(data.sourceName))
                      if (_.includes(data.sourceName.toLowerCase(), 'aydınlatma'))
                        return 'Elektrik';
                    return 'Mekanik';
                  case 'IfcFurnishingElement':
                    return 'Mobilya';
                  default:
                    break;
                }
                return 'Diğer';
              }
              if (angular.isDefined(data.sourceName)) {
                if (_.includes(data.sourceName.toLowerCase(),'pencere'))
                  return 'Mimari';
                if (_.includes(data.sourceName.toLowerCase(),'kapı'))
                  return 'Mimari';
              }
              if (angular.isDefined(data.source)&&data.source!=='')
              {
                return 'Diğer';
              }
            }
          },
          {
            caption: "Zaman",
            dataField: "time",
            dataType: "datetime",
            width: 180,
            format: "yyyy-MM-dd HH:mm",
            // calculateCellValue: function (data) {
            //   if (angular.isUndefined(data.time) || data.time === '' || data.time === null)
            //     return moment(data.creationTime, 'YYYY-MM-DD HH:mm').startOf('day').add(7, 'days').format('YYYY-MM-DD HH:mm');
            //   return data.time;
            // }
          },
          {
            caption: 'Müdahale Zamanı',
            dataField: 'response_time',
            dataType: "datetime",
            width: 180,
            format: "yyyy-MM-dd HH:mm",
            // calculateCellValue: function (data) {
            //   if (angular.isUndefined(data.response_time) || data.response_time === '' || data.response_time === null)
            //     if (angular.isUndefined(data.time) || data.time === '' || data.time === null)
            //       return moment(data.creationTime, 'YYYY-MM-DD HH:mm').startOf('day').add(7, 'days').format('YYYY-MM-DD HH:mm');
            //     else
            //       return moment(data.time, 'YYYY-MM-DD HH:mm').startOf('day').add(7, 'days').format('YYYY-MM-DD HH:mm');
            //   return data.response_time;
            // }
          },
          {
            dataField: 'message',
            caption: 'Ek Bilgi'
          },
          {
            dataField: 'fm_message',
            caption: 'FM Ek Bilgi'
          },
          {
            dataField: 'fm_technician',
            caption: 'Atanan Teknisyen'
          },
          {
            dataField: 'status',
            caption: 'Durumu',
            calculateCellValue: function (data) {
              return $filter('translate')('chart_status_' + data.status);
            }
          },
          {
            dataField: "user.username",
            headerFilter: {allowSearch: true},
            caption: "Kullanıcı Adı"
          },
        ]
      };
      $scope.getDatas();
    };
    if (angular.isDefined($window.bimSurfer) && $window.bimSurfer != null)
      $scope.initGrid();
    else
      $rootScope.$on('bimSurferLoaded', function () {
        $scope.initGrid();
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('HeaderController', HeaderController)

  ;

  /** @ngInject */
  function HeaderController($scope, coreService, $state, $rootScope, $location, $timeout, toastrConfig, $transitions,$log) {
    var vm=this
    toastrConfig.preventDuplicates = false;

    $transitions.onSuccess({}, function (transition) {
      $log.log(
        "Successful Transition from " + transition.from().name +
        " to " + transition.to().name
      );
    });

    $log.log(coreService.get_user());
    vm.isShow = function () {

      return coreService.is_logged_in();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('ComplaintTimeController', ComplaintTimeController)
  ;

  /** @ngInject */
  function ComplaintTimeController($scope, $q, bim_address, coreService, toastr, $log) {
    var vm = this;

    if (coreService.check_complaint('time')) {
      toastr.warning('Lütfen Zaman bilgisi giriniz', 'Uyarı!');
    }
    $scope.momentDate = undefined;
    if (angular.isDefined(coreService.Complaint.time) && coreService.Complaint.time != null)
      $scope.momentDate = moment(coreService.Complaint.time, 'YYYY-MM-DD HH:mm');
    $scope.timeChange = function () {
      coreService.Complaint.time = moment($scope.momentDate).format('YYYY-MM-DD HH:mm');
    };


    $scope.momentDate2 = undefined;
    if (angular.isDefined(coreService.Complaint.response_time) && coreService.Complaint.response_time != null)
      $scope.momentDate2 = moment(coreService.Complaint.response_time, 'YYYY-MM-DD HH:mm');
    $scope.timeChange2 = function () {
      coreService.Complaint.response_time = moment($scope.momentDate2).format('YYYY-MM-DD HH:mm');
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('ComplaintSourceController', ComplaintSourceController)
  ;

  /** @ngInject */
  function ComplaintSourceController($scope, $q, bim_address, coreService, bimServerService, $window, toastr, $log,$document,$filter) {
    var vm = this;

    if (coreService.check_complaint('element_type')) {
      toastr.warning('Lütfen Kaynak bilgisi giriniz', 'Uyarı!');
    } else if (coreService.check_complaint('related_element')) {
      toastr.warning('Lütfen Kaynak bilgisi giriniz', 'Uyarı!');
    } else if (coreService.check_complaint('source_location')) {
      toastr.warning('Lütfen Kaynak bilgisi giriniz', 'Uyarı!');
    }

    $scope.rightNavOpen = false;
    vm.funcSetGuid = function (guid) {
      bimServerService.loadRelatedElementByGuid(guid).then(function (data) {
        coreService.Complaint.source=data;
        if (angular.isDefined(data) && data != null&&angular.isDefined(data.guid) && data.guid != null)
          bimServerService.str('sour').then(function (data) {
            $document[0].getElementById('loc_lbl').innerText = data[$scope.source_selected];
          });
        else
          $document[0].getElementById('loc_lbl').innerText="";
        vm.selectSpace();
      },function (e) {
        $log.log(e);
      });
    };
    if (coreService.is_logged_in()) {
      if (angular.isDefined(coreService.Complaint.source)) {
        if (coreService.Complaint.source !== null) {
          if (angular.isDefined(coreService.Complaint.source) && coreService.Complaint.source != null) {
            bimServerService.clearSelection();
            vm.funcSetGuid(coreService.Complaint.source.guid);
          }
        }
      }
    }
    vm.selectSpace = function () {
      if (coreService.is_logged_in()) {
        if (angular.isDefined(coreService.Complaint.source)) {
          if (coreService.Complaint.source !== null) {
            $window.bimSurfer.setSelection({

              ids: [coreService.User.roid + ':' + $window.bimSurfer.toId([coreService.Complaint.source.guid])[0]],
              selected: true
            });
          }
        }
      }
    };
    vm.isLoad = false;
    vm.loadData = function () {
      bimServerService.load(vm.funcSetGuid).then(function () {
        bimServerService.resizeMap('md');
        $window.bimSurfer.viewer.scene.input.addEventListeners();
        $window.bimSurfer.on("loading-finished", function () {
          bimServerService.resetCamera();
          vm.selectSpace();
          $scope.locationOn();
        });

      });
    };
    $scope.btn_color1 = "md-raised md-primary  flex";
    $scope.btn_color2 = "md-raised md-primary md-disabled flex";
    $scope.source_selected = 0;
    $scope.currentNavItem = 'element';
    $scope.element_selected = 0;
    $scope.eDisabled = function (index) {
      return $scope.element_selected === index;
    };
    $scope.resetCamera = function () {
      if ($scope.source_selected === 1)
        bimServerService.resetCamera();
      else {
        if ($scope.element_selected === 0) {
          bimServerService.resetCamera();
        }
        else if ($scope.element_selected === 1) {
          bimServerService.resetReverseCamera();
        }
      }
    };
    $scope.zoomInCamera = function () {
      bimServerService.zoomInCamera ();
    };
    $scope.zoomOutCamera  = function () {
      bimServerService.zoomOutCamera();
    };
    $scope.locationOn  = function () {
      if(angular.isDefined(coreService.User.location)&&coreService.User.location!=null)
      {
        bimServerService.clearSelection();
        vm.funcSetGuid(coreService.User.location);
      }
    };
    $scope.onChange = function (cbState) {

      if (cbState === 0) {
        bimServerService.resetCamera();
        $scope.btn_color1 = "md-raised md-primary  flex";
        $scope.btn_color2 = "md-raised md-primary md-disabled flex";
        $scope.element_selected = 0;

      }
      else if (cbState === 1) {
        $scope.btn_color2 = "md-raised md-primary  flex";
        $scope.btn_color1 = "md-raised md-primary md-disabled flex";
        bimServerService.resetReverseCamera();
        $scope.element_selected = 1;
      }
    };
    $scope.hideElementSpaces = function () {
      return $scope.source_selected === 0;
    };
    $scope.hideElementBtns = function () {
      return $scope.source_selected === 1;
    };
    $scope.selectTab = function (command) {
      if (angular.isDefined(command) && ['element', 'location'].indexOf(command) !== -1) {
        if (command === 'element') {
          $scope.source_selected = 0;
          $scope.element_selected = 0;
          bimServerService.resizeMap('md');
          $scope.resetCamera();
          $document[0].getElementById('loc_lbl').innerText="";
        }
        else if (command === 'location') {
          $scope.source_selected = 1;
          bimServerService.resizeMap('xs');
          $scope.resetCamera();
          $document[0].getElementById('loc_lbl').innerText="";
        }
      }
      else
        toastr.error('Invalid state of tabs, please reload page', 'Error');
    };

    $scope.space = null;
    $scope.spaces = undefined;
    $scope.closeSpace = function () {
      if ($document[0].getElementById('xeoglShadowDiv') != null)
        $document[0].getElementById('xeoglShadowDiv').style["visibility"] = "visible";
    };
    $scope.openSpace=function(){
      if ($document[0].getElementById('xeoglShadowDiv') != null)
        $document[0].getElementById('xeoglShadowDiv').style["visibility"] = "hidden";
    };
    $scope.loadSpaces = function () {

      if (angular.isDefined($scope.spaces))
        return $scope.spaces;
      bimServerService.getDataObjectsByType('IfcSpace').then(function (data) {
        $scope.spaces = data.map(function (a) {
          return {id: a.guid, name: a.name}
        });
        if (coreService.is_logged_in()) {
          if (coreService.Complaint.source !== null) {
            $scope.space = $filter('filter')($scope.spaces, {id: coreService.Complaint.source})[0];
          }
        }
      });
    };
    $scope.updateSpace = function () {
      coreService.Complaint.source = $scope.space.id;
      bimServerService.resetCamera();
      vm.funcSetGuid($scope.space.id);
    };
    $scope.loadSpaces();
    vm.loadData();
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('ComplaintPreviewController', ComplaintPreviewController)
  ;

  /** @ngInject */
  function ComplaintPreviewController($scope, $filter, $q, bim_address, coreService, toastr, $log, bimServerService) {
    var vm = this;
    $log.log(coreService.User);
    if (angular.isUndefined(coreService.Complaint)||coreService.Complaint==null)
      $log.error('Complaint is null');
    $scope.indicator = $filter('translate')(coreService.Complaint.indicator);
    bimServerService.str('loc').then(function (data) {
      $scope.locationName=data;
    });
    bimServerService.str('sour').then(function (data) {
      if (angular.isUndefined(data)||data==null||data==='') return;
      $scope.sourceName=data[0];
    });

    $scope.message = coreService.Complaint.message;
    $scope.time = coreService.Complaint.time;
    $scope.response_time = coreService.Complaint.response_time ;
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('ComplaintMessageController', ComplaintMessageController)
  ;

  /** @ngInject */
  function ComplaintMessageController($scope, $q, bim_address, coreService, toastr, $log) {
    var vm = this;
    $scope.textChange = function () {
      coreService.Complaint.message = $scope.textMessage;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('ComplaintLocationController', ComplaintLocationController)
  ;

  /** @ngInject */
  function ComplaintLocationController($scope, $q, bim_address, coreService, bimServerService, toastr, $window, $log, $document, $filter) {
    var vm = this;
    $scope.selectedTabIndex = 0;
    $scope.toast = undefined;


    if (coreService.check_complaint('location')) {
      toastr.warning('Lütfen Konum bilgisinden lokasyon giriniz', 'Uyarı!');
    } else if (coreService.check_complaint('room')) {
      toastr.warning('Lütfen Konum bilgisinden oda seçiniz', 'Uyarı!');
    }
    vm.funcSetGuid = function (guid) {

      bimServerService.loadRelatedElementByGuid(guid).then(function (data) {
        coreService.Complaint.location = data;
        if (angular.isDefined(data) && data != null&&angular.isDefined(data.guid) && data.guid != null)
          bimServerService.str('loc').then(function (data) {
              $document[0].getElementById('loc_lbl').innerText = data;
          });
        else
          $document[0].getElementById('loc_lbl').innerText="";
        vm.selectSpace();
      }, function (e) {
        $log.log(e);
      });
    };
    if (coreService.is_logged_in()) {
      if (angular.isDefined(coreService.Complaint.location)) {
        if (coreService.Complaint.location !== null) {
          if (angular.isDefined(coreService.Complaint.location) && coreService.Complaint.location != null) {
            bimServerService.clearSelection();
            vm.funcSetGuid(coreService.Complaint.location.guid);
          }
        }
      }
    }

    vm.selectSpace = function () {
      if (coreService.is_logged_in()) {
        if (angular.isDefined(coreService.Complaint.location)) {
          if (coreService.Complaint.location !== null) {
            $window.bimSurfer.setSelection({

              ids: [coreService.User.roid + ':' + $window.bimSurfer.toId([coreService.Complaint.location.guid])[0]],
              selected: true
            });
          }

        }
      }
    };

    vm.loadData = function () {
      bimServerService.load(vm.funcSetGuid).then(function () {
        $window.bimSurfer.viewer.scene.input.addEventListeners();
        $window.bimSurfer.on("loading-finished", function () {
          bimServerService.resetCamera();

          vm.selectSpace();
          $scope.locationOn();
        });
        bimServerService.resizeMap();
      });
    };
    $scope.resetCamera = function () {
      if (angular.isDefined($window.bimSurfer) && $window.bimSurfer != null) {
        bimServerService.resetCamera();
      }
    };
    $scope.zoomInCamera = function () {
      bimServerService.zoomInCamera();
    };
    $scope.zoomOutCamera = function () {
      bimServerService.zoomOutCamera();
    };
    $scope.locationOn = function () {
      if (angular.isDefined(coreService.User.location) && coreService.User.location != null) {
        bimServerService.clearSelection();
        vm.funcSetGuid(coreService.User.location);
      }
    };


    $scope.source_selected = 0;
    $scope.currentNavItem = 'map';
    $scope.selectTab = function (command) {
      if (angular.isDefined(command) && ['map', 'list'].indexOf(command) !== -1) {
        if (command === 'map') {
          $scope.source_selected = 0;
          bimServerService.resizeMap();
          $scope.element_selected = 0;
          $scope.resetCamera();
          $document[0].getElementById('loc_lbl').innerText="";
        }
        else if (command === 'list') {
          $scope.source_selected = 1;
          bimServerService.resizeMap('sm');
          $scope.resetCamera();
          $document[0].getElementById('loc_lbl').innerText="";
        }
      }
      else
        toastr.error('Invalid state of tabs, please reload page', 'Error');
    };

    $scope.hideElementSpaces = function () {
      return $scope.source_selected === 0;
    };

    $scope.updateSpace = function () {
      coreService.Complaint.location = $scope.space.id;
      bimServerService.resetCamera();
      vm.funcSetGuid($scope.space.id);
    };
    $scope.space = null;
    $scope.spaces = undefined;
    $scope.closeSpace = function () {
      if ($document[0].getElementById('xeoglShadowDiv') != null)
        $document[0].getElementById('xeoglShadowDiv').style["visibility"] = "visible";
    };
    $scope.openSpace = function () {
      if ($document[0].getElementById('xeoglShadowDiv') != null)
        $document[0].getElementById('xeoglShadowDiv').style["visibility"] = "hidden";
    };
    $scope.loadSpaces = function () {

      if (angular.isDefined($scope.spaces))
        return $scope.spaces;
      bimServerService.loadSpaces().then(function (data) {
        $scope.spaces = data;
        if (coreService.is_logged_in()) {
          if (coreService.Complaint.location !== null) {
            $scope.space = $filter('filter')($scope.spaces, {id: coreService.Complaint.location})[0];
          }
        }
      });
    };
    $scope.loadSpaces();
    vm.loadData();
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('ComplaintInsertController', ComplaintInsertController)
  ;

  /** @ngInject */
  function ComplaintInsertController($scope, $rootScope, $q, $timeout, $state, coreService, utilsService, $log, $filter, toastr, $window) {
    var vm = this;

    /**
     * BEGIN AUTOCOMPLETE
     * */
    $log.log(coreService.Complaint);
    if (angular.isUndefined(coreService.Complaint.indicator) || coreService.Complaint.indicator == null ||
      (coreService.Complaint.type !== "list" &&
        (angular.isUndefined(coreService.Complaint.orderObj) || coreService.Complaint.orderObj == null))) {
      toastr.warning('Lütfen bir şikayet giriniz!', 'Uyarı!');
    }
    $scope.selectedTabIndex = 0;
    $scope.dimension = null;
    $scope.dimensions = null;
    $scope.criteria = null;
    $scope.criterias = null;
    $scope.indicator = null;
    $scope.indicators = null;
    vm.isDisabled = false;
    vm.noCache = false;
    $scope.searchText = "";
    $scope.selectedSearchItem = null;
    vm.allStates = [];
    vm.states = function () {
      if (vm.allStates.length > 0)
        return vm.allStates;
      var order_names = utilsService.get_order_names();
      for (var i in order_names) {
        var item = order_names[i];
        vm.allStates.push({
          id: item,
          value: $filter('translate')(item)
        });
      }
      return vm.allStates;
    };
    $scope.search_selectedItem = undefined;
    vm.states();

    vm.createFilterFor = function (query) {
      var lowercaseQuery = query.toLowerCase();
      return function filterFn(state) {
        return (state.value.toLowerCase().indexOf(lowercaseQuery.toLowerCase()) !== -1);
      };
    };

    $scope.querySearch = function (query) {
      return query ? vm.states().filter(vm.createFilterFor(query)) : vm.states();
    };
    $scope.selectedItemChange = function (item) {
      if (angular.isUndefined(item)) {
        coreService.Complaint.orderObj = undefined;

        return;
      }
      else {
        $log.log($filter('translate')(item.id));
        coreService.Complaint.orderObj = utilsService.parse_orders(item.id);
        var rt = utilsService.get_complaint_from_indicator(item.id);
        coreService.Complaint.dimension = rt.dimension;
        coreService.Complaint.criteria = rt.criteria;
        coreService.Complaint.indicator = rt.indicator;
        coreService.Complaint.type = 'search';
      }
      $log.info('Item changed to ' + JSON.stringify(item.value));
    };
    vm.searchTextChange = function (text) {
      $log.info('Text changed to ' + text);
    };

    vm.openMenu = function ($mdMenu, ev) {
      $mdMenu.open(ev);
    };


    vm.selectTab = function (command) {
      //coreService.Complaint={};
    };


    $scope._resetComplaintInsert = function () {
      $scope.criteria = null;
      $scope.indicator = null;
    };
    $scope.loadDimensions = function () {
      $scope.dimensions = utilsService.get_dimensions();
      $scope._resetComplaintInsert();
    };

    $scope.updateDimension = function () {
      $scope.criterias = utilsService.get_criterias($scope.dimension.id);
    };

    $scope.updateCriteria = function () {
      $scope.indicators = utilsService.get_indicators($scope.dimension.id, $scope.criteria.id);
    };

    $scope.updateIndicator = function () {
      coreService.Complaint.dimension = $scope.dimension.id;
      coreService.Complaint.criteria = $scope.criteria.id;
      coreService.Complaint.indicator = $scope.indicator.id;
      coreService.Complaint.orderObj = utilsService.parse_orders(coreService.Complaint.indicator);
      coreService.Complaint.type = 'list';
    };
    if (coreService.is_logged_in()) {
      $window.User = coreService.User;
      if (coreService.Complaint != null)
        switch (coreService.Complaint.type) {
          case 'search':
            $scope.selectedTabIndex = 0;
            $scope.search_selectedItem = {
              id: coreService.Complaint.indicator,
              value: $filter('translate')(coreService.Complaint.indicator)
            };
            break;
          case 'list':
            $scope.loadDimensions();
            $scope.selectedTabIndex = 1;
            $scope.selected_dimension = coreService.Complaint.dimension;
            $scope.selected_criteria = coreService.Complaint.criteria;
            $scope.selected_indicator = coreService.Complaint.indicator;

            $scope.dimension = {
              id: coreService.Complaint.dimension,
              name: $filter('translate')(coreService.Complaint.dimension)
            };
            $scope.updateDimension();
            $scope.criteria = {
              id: coreService.Complaint.criteria,
              name: $filter('translate')(coreService.Complaint.criteria)
            };
            $scope.updateCriteria();
            $scope.indicator = {
              id: coreService.Complaint.indicator,
              name: $filter('translate')(coreService.Complaint.indicator)
            };
            $scope.updateIndicator();


            break;
          case 'write':
            $scope.selectedTabIndex = 2;
            break;
          case null:
            break;
          default:
            delete  coreService.Complaint.dimension;
            delete  coreService.Complaint.criteria;
            delete  coreService.Complaint.indicator;
            break;
        }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('rwHeader', rwHeaderDir);

  /** @ngInject */
  function rwHeaderDir() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/directive/header/header.tpl.html',
      bindToController: {
        rwSelected: '='
      },
      controller: RwHeaderController,
      controllerAs: 'vm'
    };

    return directive;
  }

  /** @ngInject */
  function RwHeaderController($scope, coreService, $state,bimServerService,$document ) {
    var vm = this;
    $scope.sDisabled = function (index) {
      return vm.rwSelected === index;
    };
    $scope.closeMap = function () {
      if ($document[0].getElementById('xeoglShadowDiv') != null)
        $document[0].getElementById('xeoglShadowDiv').style["visibility"] = "visible";
    };
    $scope.openMap = function () {
      if ($document[0].getElementById('xeoglShadowDiv') != null)
        $document[0].getElementById('xeoglShadowDiv').style["visibility"] = "hidden";
    };
    $scope.openMenu = function ($mdMenu, ev) {
      $mdMenu.open(ev);
      $scope.openMap();
    };
    $scope.closeMenu = function ($mdMenu, ev) {
      $mdMenu.close(ev);
      $scope.closeMap();
    };
    $scope.submitBtn = function (cmd) {
      $scope.closeMap();
      bimServerService.checkBimSurfer();
      switch (cmd) {
        case "t_main":
          console.log(JSON.stringify(coreService.Complaint));
          coreService.Complaint={};
          $state.go('main');

          break;
        case "t_complaint":
          $state.go('rw_new_enter');
          break;
        case "t_location":
          $state.go('rw_location');
          break;
        case "t_source":
          $state.go('rw_source');
          break;
        case "t_time":
          $state.go('rw_time');
          break;
        case "t_extra_info":
          $state.go('rw_message');
          break;
        case "rw_logout":
          coreService.logout_user();
          $state.go('login');
          break;
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('rwFooter', rwFooterDirective);

  /** @ngInject */
  function rwFooterDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/directive/footer/footer.tpl.html',
      bindToController: {
        rwSelected: '='
      },
      controller: FooterController,
      controllerAs: 'vm'
    };

    return directive;
  }

  /** @ngInject */
  function FooterController($scope, $rootScope, $state, $log, coreService, $window, bimServerService, toastr) {
    var vm = this;
    $log.log(vm.rwSelected);
    vm.disNextBtn = function () {
      return vm.rwSelected >= 5;
    };
    vm.disPrevBtn = function () {
      return vm.rwSelected <= 0;
    };
    $scope.hideSubmitBtn = function () {
      return vm.rwSelected !== 5;
    };
    vm.submit_btn = function () {
      $log.log(coreService.Complaint);

      if ($scope.isValid()) {
        bimServerService.sendComplaint(coreService.Complaint).then(function () {
          coreService.Complaint = {};
          toastr.success('Şikayetiniz iletildi!', 'Gönderim başarılı!');
          $state.go('main');
        });
      }
    };

    function _v(value, c_m) {
      if (angular.isUndefined(c_m))
        return angular.isDefined(value) && value != null && value === 'must';
      else
        return angular.isDefined(value) && value != null;
    }

    $scope.isValid = function () {
      var res = true;
      if (angular.isUndefined(coreService.Complaint.indicator) || coreService.Complaint.indicator == null ||
        (coreService.Complaint.type !== "list" &&
          (angular.isUndefined(coreService.Complaint.orderObj) || coreService.Complaint.orderObj == null))) {
        toastr.error('Lütfen bir şikayet giriniz!', 'Hata!');
        return false;
      }

      if (coreService.check_complaint('location')) {
        toastr.error('Lütfen Konum bilgisinden lokasyon giriniz', 'Hata!');
        res = false;
      } else if (coreService.check_complaint('room')) {
        toastr.error('Lütfen Konum bilgisinden oda seçiniz', 'Hata!');
        res = false;
      }

      if (coreService.check_complaint('element_type')) {
        toastr.error('Lütfen Kaynak bilgisi giriniz', 'Hata!');
        res = false;
      } else if (coreService.check_complaint('related_element')) {
        toastr.error('Lütfen Kaynak bilgisi giriniz', 'Hata!');
        res = false;
      } else if (coreService.check_complaint('source_location')) {
        toastr.error('Lütfen Kaynak bilgisi giriniz', 'Hata!');
        res = false;
      }

      if (coreService.check_complaint('time')) {
        toastr.error('Lütfen Zaman bilgisi giriniz', 'Hata!');
        res = false;
      }
      return res;
    };

    $scope.progress_btn = function (command) {
      var state = '';
      bimServerService.checkBimSurfer();
      switch (command) {
        case 'prev':
          switch (vm.rwSelected) {
            case 1:
              state = 'rw_new_enter';
              break;
            case 2:
              state = 'rw_location';
              break;
            case 3:
              state = 'rw_source';
              break;
            case 4:
              state = 'rw_time';
              break;
            case 5:
              state = 'rw_message';
              break;
          }
          break;
        case 'next':
          coreService.set_user();

          switch (vm.rwSelected) {
            case 0:
              state = 'rw_location';
              break;
            case 1:
              state = 'rw_source';
              break;
            case 2:
              state = 'rw_time';
              break;
            case 3:
              state = 'rw_message';
              break;
            case 4:
              state = 'rw_preview';
              break;
          }
          break;
      }
      $state.go(state);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('AdminMainController', AdminMainController);

  /** @ngInject */
  function AdminMainController($scope, $rootScope, coreService, utilsService, $log, $filter, toastr, $window, bimServerService, $interval) {
    var vm = this;
    // GridList Configurations
    $scope.grid_datas = [];
    $scope.grid_columns = [];
    $scope.getDatas = function () {
      bimServerService.getComplaints().then(function (data) {
        $scope.grid_datas = data.result;
        vm.getChartData(data.result);
      });
    };

    // GridList Configurations
    $scope.bimModelOptions = {};

    $scope.selectedComplaint = null;
    $scope.chart_data = [];
    $scope.options = {
      "chart": {
        "type": "multiBarChart",
        "height": 450,
        "margin": {
          "top": 20,
          "right": 20,
          "bottom": 45,
          "left": 45
        },
        // "clipEdge": true,
        // "duration": 500,
        "stacked": true,
        "xAxis": {
          "axisLabel": "Tarih Ay",
          "showMaxMin": true
        },
        "yAxis": {
          "axisLabel": "Şikayetler",
          "axisLabelDistance": -20,
          "tickFormat": function (d) {
            return d3.format('s')(d);
          }
        },
        "showValues": true,
        "showControls": false
      }
    };
    // $scope.chartOptions = {};

    $scope.chartOptions = {
      bindingOptions: {
        dataSource: {
          <!-- Enables deep tracking of changes -->
          deep: true,
          <!-- Specifies which scope property to track changes in -->
          dataPath: 'chart_data'
        }
      },
      // screenByWidth: function(width) {
      //   return ( width < 700 ) ? 'sm' : 'lg';
      // },
      commonSeriesSettings: {
        argumentField: "state",
        type: "stackedBar"
      },
      onPointClick: function (e) {
        e.target.select();
      },
      onLegendClick: function (e) {
        var series = e.target;
        if (series.isVisible()) {
          series.hide();
        } else {
          series.show();
        }
      },
      series: [
        // {valueField: "approved", name: $filter('translate')('chart_status_approved')},
        // {valueField: "waiting", name: $filter('translate')('chart_status_waiting')},
        // {valueField: "rejected", name: $filter('translate')('chart_status_rejected')},
        // {valueField: "terminated", name: $filter('translate')('chart_status_terminated')},
        {valueField: "approved", name: "Onaylandı"},
        {valueField: "waiting", name: "Beklemede"},
        {valueField: "rejected", name: "Reddedildi"},
        {valueField: "terminated", name: "Sonlandırıldı"}
      ],
      legend: {
        verticalAlignment: "bottom",
        horizontalAlignment: "center",
        itemTextPosition: 'top'
      },
      valueAxis: {
        title: {
          text: "adet"
        },
        position: "right"
      },
      title: "Şikayetler",
      "export": {
        enabled: true
      },
      tooltip: {
        enabled: true,
        location: "edge",
        customizeTooltip: function (arg) {
          return {
            text: arg.seriesName + " ay: " + arg.valueText
          };
        }
      }
    };


    vm.getChartData = function (data) {
      $scope.chart_data = _.map(_.groupBy(data, 'year_month'), function (y, j) {
        return {
          state: j,
          approved: Math.trunc($filter('filter')(y, function (a) {
            return a.status === 'approved'
          }).length),
          waiting: Math.trunc($filter('filter')(y, function (a) {
            return a.status === 'waiting'
          }).length),
          rejected: Math.trunc($filter('filter')(y, function (a) {
            return a.status === 'rejected'
          }).length),
          terminated: Math.trunc($filter('filter')(y, function (a) {
            return a.status === 'terminated'
          }).length)
        }
      })
    };

    $scope.initGrid = function () {
      $scope.gridOptions = {
        showBorders: true,
        showRowLines: true,
        rowAlternationEnabled: true,
        allowColumnResizing: true,
        columnAutoWidth: true,
        filterRow: {visible: true},
        filterPanel: {visible: true},
        headerFilter: {visible: true},
        paging: {
          pageSize: 5
        },
        columnChooser: {
          enabled: true,
          mode: "select"
        },
        export: {
          enabled: true,
          fileName: "Complaints",
          allowExportSelectedData: true
        },
        onExporting: function (e) {
          if (angular.isDefined($scope.export_stop)) {
            e.cancel = true;
          }
          // Handler of the "exporting" event
          $scope.export_stop = $interval(function () {
            $interval.cancel($scope.export_stop);
            $scope.export_stop = undefined;
          }, 1000);
        },
        selection: {
          mode: "multiple"
        },
        bindingOptions: {
          dataSource: {
            <!-- Enables deep tracking of changes -->
            deep: true,
            <!-- Specifies which scope property to track changes in -->
            dataPath: 'grid_datas'
          }
        },
        columns: [{
          caption: 'buttons',
          type: 'buttons',
          width: 230,
          allowHiding: false,
          showInColumnChooser: false,
          buttons: [
            {
              hint: "Modelde Göster",
              icon: "search",
              onClick: function (e) {
                var id = e.row.data.index;
                $scope.selectedComplaint = _.first(_.filter($scope.grid_datas, ['index', id]));
                if (angular.isDefined($scope.bimModelOptions.viewComplaint))
                  $scope.bimModelOptions.viewComplaint($scope.selectedComplaint);
              }
            }
          ]
        },
          {
            dataField: "index",
            headerFilter: {allowSearch: true},
            dataType: 'Number',
            caption: "Şikayet No"
          },
          {
            dataField: "indicator",
            caption: "Şikayet",
            headerFilter: {allowSearch: true},
            calculateCellValue: function (data) {
              return $filter('translate')(data.indicator);
            }
          },
          {
            dataField: "user.username",
            headerFilter: {allowSearch: true},
            caption: "Kullanıcı Adı"
          },
        ]
      };
      $scope.getDatas();
    };
    $scope.initGrid();
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('AdminLoginController', AdminLoginController);

  /** @ngInject */
  function AdminLoginController($state,$scope, loginService,coreService,toastr,$log,$stateParams) {
    var vm = this;
    vm.loginModel = {
      username: '',
      password: ''
    };

    coreService.logout_user();
    vm.submitForm = function () {
      $log.log(vm.loginModel);
      loginService.login(vm.loginModel.username, vm.loginModel.password).then(function () {
        $log.log(coreService.get_user());
        if (angular.isDefined($stateParams.sp)&&$stateParams.sp!=null)
          coreService.User.location=$stateParams.sp;
        coreService.set_user();
        $state.go('ad_main', {user:coreService.get_user()});
      }).catch(function (response) {
        $log.error(response);
        toastr.error(response, 'Hata!');
      }).finally(function () {
        $log.log("login finally finished ");
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('adminLoading', adminLoadingDir);

  /** @ngInject */
  function adminLoadingDir() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/admin/directive/loading/admin.loading.tpl.html',

      controller: AdminLoadingController,
      controllerAs: 'vm'
    };

    return directive;
  }

  /** @ngInject */
  function AdminLoadingController($scope, bimServerService, $document,$window) {
    var vm = this;
    $scope.isloaded = function () {
      return angular.isDefined($window.bimSurfer);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('adminComplaintView', adminComplaintViewDir);

  /** @ngInject */
  function adminComplaintViewDir() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/admin/directive/complaintView/admin.complaint.view.tpl.html',
      scope: {
        selectedComplaint: '='
      },
      controller: AdminComplaintViewController,
      controllerAs: 'vm'
    };

    return directive;
  }

  /** @ngInject */
  function AdminComplaintViewController($scope, bimServerService, $document, $window, $filter, utilsService, $mdDialog, rw_orders, toastr, $timeout, $state) {
    var vm = this;
    $scope.indicator = null;
    $scope.status = null;
    $scope.technician = null;
    $scope.momentDate = undefined;

    $scope.select_indicators = utilsService.getComplaint().getAllIndicators();
    $scope.updateIndicator = function () {
    };

    $scope.$watch('selectedComplaint', function (a) {
      if (angular.isUndefined(a) || a == null)
        return;
      // $scope.selectedIndicator = a.indicator;
      // $scope.selectedStatus = a.status;
      // $scope.selectedTechnician = a.fm_technician;
      if (angular.isDefined(a.response_time) && a.response_time !== '')
        $scope.momentDate = moment(a.response_time, 'YYYY-MM-DD HH:mm');
    });

    $scope.statuses = ["approved", "waiting", "rejected", "terminated"].map(function (a) {
      return {id: a, name: $filter('translate')("chart_status_" + a)}
    });
    $scope.technicians = ["Teknisyen-1", "Teknisyen-2", "Teknisyen-3", "Teknisyen-4"].map(function (a) {
      return {id: a, name: a}
    });

    $scope.selectedIndicator = undefined;
    $scope.selectedStatus = undefined;
    $scope.selectedTechnician = undefined;
    $scope.editedComplaint = undefined;
    $scope.show_edit = function (ev) {
      $scope.editedComplaint = $scope.selectedComplaint;
      $scope.selectedTechnician = $scope.editedComplaint.fm_technician;
      $scope.technician = {id: $scope.selectedTechnician, name: $scope.selectedTechnician};
      $scope.selectedIndicator = $scope.editedComplaint.indicator;
      $scope.selectedStatus = $scope.editedComplaint.status;
      $mdDialog.show({
        contentElement: '#editDialog',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      }).then(function (answer) {
        //ok
        $scope.technician = undefined;
        $scope.editedComplaint = undefined;
        $scope.selectedStatus = undefined;
        $scope.selectedTechnician = undefined;
        $scope.momentDate = undefined;
        $scope.selectedIndicator = undefined;
      }, function () {
        $scope.technician = undefined;
        $scope.editedComplaint = undefined;
        $scope.selectedStatus = undefined;
        $scope.selectedTechnician = undefined;
        $scope.momentDate = undefined;
        $scope.selectedIndicator = undefined;
        //error
      });
    };
    $scope.hide_edit = function () {
      $mdDialog.hide();
    };
    $scope.submit_edit = function () {
      debugger;
      // var res = utilsService.getComplaint().getComplaintDataByIndicator($scope.indicator.id);

      if (angular.isDefined($scope.momentDate) && $scope.momentDate !== '')
        $scope.editedComplaint.response_time = moment($scope.momentDate).format('YYYY-MM-DD HH:mm');

      if (angular.isDefined($scope.status) && $scope.status !== '')
        $scope.editedComplaint.status = $scope.status.id;

      if (angular.isDefined($scope.technician) && $scope.technician !== '')
        $scope.editedComplaint.fm_technician = $scope.technician.id;

      bimServerService.sendUpdateComplaint($scope.editedComplaint).then(function () {
        $scope.editedComplaint = undefined;
        toastr.success('Şikayet güncellendi, birazdan ekranınız güncellenecektir.', 'Gönderim başarılı!');
        $state.reload();
      });
    };

    $scope.disableEdit = function () {
      return !(angular.isDefined($scope.selectedComplaint) && $scope.selectedComplaint !== '' && $scope.selectedComplaint !== null);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('adminHeader', adminHeaderDir);

  /** @ngInject */
  function adminHeaderDir() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/admin/directive/header/header.tpl.html',
      bindToController: {
        adminPageSelected: '='
      },
      controller: AdminHeaderController,
      controllerAs: 'vm'
    };

    return directive;
  }

  /** @ngInject */
  function AdminHeaderController($scope, bimServerService, $document,coreService,$log,$timeout,$location) {
    var vm = this;


  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('adminFooter', adminFooterDirective);

  /** @ngInject */
  function adminFooterDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/admin/directive/footer/footer.tpl.html',
      bindToController: {
         adminPageSelected: '='
      },
      controller: AdminFooterController,
      controllerAs: 'vm'
    };

    return directive;
  }

  /** @ngInject */
  function AdminFooterController($scope, $rootScope, $log, $window, bimServerService, toastr) {
    var vm = this;
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('complaintGridList', complaintGridListDirective)
  ;

  /** @ngInject */
  function complaintGridListDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/admin/directive/complaintGridList/complaint.gridlist.tpl.html',
      scope: {
        data: '=',
        columns: '=',
        superColDefs:'=',
        selectedGridId: '='
      },
      controller: complaintGridListController,
      controllerAs: 'vm'
    };

    return directive;
  }

  /** @ngInject */
  function complaintGridListController($scope,$log) {
    var vm = this;
    vm.columnDefs = [];
    $scope.query = {
      order: 'time',
      limit: 20,
      page: 1
    };
    vm.view_btn = function (id) {
      vm.selectedGridId=id;
      $log.debug(id);
    };


    $scope.gridOptions = {
      bindingOptions: {
        dataSource: {
          <!-- Enables deep tracking of changes -->
          deep: true,
          <!-- Specifies which scope property to track changes in -->
          dataPath: 'data'
        }
      },
    };
    /*$scope.$watch(function () {
      return vm.superColDefs;
    }, function (value) {
      $scope.gridOptions.superColDefs = value;
    });
    $scope.$watch(function () {
      return vm.columns;
    }, function (value) {
      $scope.gridOptions.columnDefs = value;
    });
    $scope.gridOptions.onRegisterApi = function(gridApi) {
      //set gridApi on scope
      $scope.gridApi = gridApi;
    };*/
    vm.parseCoords=function(item){
      if (angular.isDefined(item.typeName)&&item.typeName!=='')
        return item.typeName+ "--" +item.guid;
      return item.guid;
    };

    vm.parceCoordsName=function (type,data) {
      var deferred = $q.defer();
      switch (type) {
        case 'loc':
          bimServerService.str('loc').then(function (data) {
            return  deferred.resolve(data);
          });
          break;
        case 'sour':
          bimServerService.str('loc').then(function (data) {
            return  deferred.resolve(data[0]);
          });
          break;
        default:
          return deferred.resolve('');
          break;
      }
      return deferred.promise;

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('bimModel', bimModelDirective);

  /** @ngInject */
  function bimModelDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/admin/directive/bimModel/bim.model.tpl.html',
      scope: {
        options: '=',
        complaint: '=',
        isfull: '=',
        funcSetGuid: '&',
        bimLoaded: '&'
      },
      // bindToController: true,
      controller: bimModelController,
      controllerAs: 'vm'
    };

    return directive;
  }

  /** @ngInject */
  function bimModelController($scope, $log, coreService, bimServerService, $window, $document) {
    var vm = this;
    $scope.$watch('isfull', function (a) {
      if (angular.isDefined($window.bimSurfer) && $window.bimSurfer != null) {
        if (angular.isUndefined($scope.isfull) || $scope.isfull !== true) {
          if ($document[0].getElementById('canvas') !== undefined)
            $document[0].getElementById('canvas').style.height = '300px';
        } else if ($document[0].getElementById('canvas') !== undefined)
          $document[0].getElementById('canvas').style.height = (window.innerHeight - 250) + "px";
      }
    });
    $scope.locationShow = false;
    vm.selectSpace = function (guid) {
      if (coreService.is_logged_in()) {
        bimServerService.clearSelection();
        if (angular.isDefined(guid)) {
          if (guid !== null) {
            $window.bimSurfer.setSelection({

              ids: [coreService.User.roid + ':' + $window.bimSurfer.toId([guid])[0]],
              selected: true
            });
          }
        }
      }
    };
    bimServerService.load($scope.funcSetGuid).then(function () {
      $window.bimSurfer.viewer.scene.input.addEventListeners();
      $window.bimSurfer.on("loading-finished", function () {
        if (angular.isDefined($scope.bimLoaded))
          $scope.bimLoaded(null);
      });
      $window.bimSurfer.on("loading-finished", function () {
        bimServerService.resetCamera();
        if (angular.isUndefined($scope.isfull) || $scope.isfull !== true)
          $document[0].getElementById('canvas').style.height = '300px';
        else
          $document[0].getElementById('canvas').style.height = (window.innerHeight - 250) + "px";
      });
    });
    $scope.resetCamera = function () {
      if (angular.isDefined($window.bimSurfer) && $window.bimSurfer != null) {
        bimServerService.resetCamera();
      }
    };
    $scope.zoomInCamera = function () {
      bimServerService.zoomInCamera();
    };
    $scope.zoomOutCamera = function () {
      bimServerService.zoomOutCamera();
    };

    angular.extend($scope.options, {
      isloaded: function () {
        return angular.isDefined($window.bimSurfer);
      },
      view: function (comp, type) {
        if (angular.isUndefined($scope.complaint) || $scope.complaint === null)
          if (angular.isUndefined(comp) || comp === null)
            return;
          else
            $scope.complaint = comp;
        switch (type) {
          case 'sor':
            if (angular.isDefined($scope.complaint.source) && $scope.complaint.source !== '') {
              bimServerService.str('loc', $scope.complaint.source).then(function (data) {
                $scope.complaint = comp;
                bimServerService.resetCamera();
                $scope.complaint.sourceName = data;
                vm.selectSpace($scope.complaint.source.guid);
              });
            }
            break;
          case 'loc':
            if (angular.isDefined($scope.complaint.location) && $scope.complaint.location !== '') {
              bimServerService.str('loc', $scope.complaint.location).then(function (data) {
                $scope.complaint = comp;
                bimServerService.resetCamera();
                $scope.complaint.locationName = data;
                vm.selectSpace($scope.complaint.location.guid);
              });
            }
            break;
        }
      },
      viewComplaint: function (data) {
        $scope.complaint = data;
        bimServerService.resetCamera();
        if (!angular.isDefined($scope.complaint))
          return;
        if (angular.isDefined($scope.complaint.location) && $scope.complaint.location !== '') {
          bimServerService.str('loc', $scope.complaint.location).then(function (data) {
            $scope.complaint.locationName = data;
            vm.selectSpace($scope.complaint.location.guid);
          });
        }
        if (angular.isDefined($scope.complaint.source) && $scope.complaint.source !== '') {
          bimServerService.str('sour', $scope.complaint.source).then(function (data) {
            $scope.complaint.sourceName = data[0];
          });
        }
      }
    });
  }
})();

(function () {
  'use strict';


  angular.module('rateWorkspaceServer')
    .directive('loading', LoadingDirective);

  /** @ngInject */
  function LoadingDirective($http) {
    var directive = {
      restrict: 'A',
      link: function (scope, elm) {
        scope.isLoading = function () {
          return $http.pendingRequests.length > 0;
        };

        scope.$watch(scope.isLoading, function (v) {
          if (v) {
            elm.show();
          } else {
            elm.hide();
          }
        });
      }
    };
    return directive;
  }
})();

(function() {
  'use strict';

  angular
      .module('rateWorkspaceServer')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Angular Material Design',
        'url': 'https://material.angularjs.org/#/',
        'description': 'The Angular reference implementation of the Google\'s Material Design specification.',
        'logo': 'angular-material.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

function updateLang( $rootScope ) {
  return {
    link: function( scope, element ) {
      var listener = function( event, translationResp ) {
        var defaultLang = "en",
          currentlang = translationResp.language;

        element.attr("lang", currentlang || defaultLang );
      };

      var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', listener);
      $rootScope.$on('$destroy', function () {
        translateChangeSuccess();
      });
    }
  };
}
angular.module('rateWorkspaceServer').directive( 'updateLanguage', updateLang );

(function() {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function () {
    'use strict';

    angular
      .module('rateWorkspaceServer')
      .service('bimServerService', BimServerService);

    /** @ngInject */
    function BimServerService($rootScope, $http, $q, bim_address, bim_complaint_address, coreService, $log, $window, $document, $filter) {
      var vm = this;
      this.checkBimSurfer = function () {
        if (angular.isDefined($window.bimSurfer)) {
          $window.bimSurfer.off("selection-changed");
          $window.bimSurfer.off("loading-finished");
          $window.bimSurfer.viewer.scene.input.removeEventListeners();
          this.resetCamera();
        }
      };
      this.zoomOutCamera = function () {
        $window.bimSurfer.viewer.scene.camera.view.zoom(40);
      };
      this.zoomInCamera = function () {
        $window.bimSurfer.viewer.scene.camera.view.zoom(-40);
      };
      this.clearSelection = function () {
        $window.bimSurfer.viewer.setSelection({clear: true});
      };
      this.resetCamera = function () {
        try {
          // this.getDataObjectsByType('IfcCovering').then(function (data) {
          //   coreService.Model.Spaces = {};
          //   var coverings=data.map(function(a) {return coreService.User.roid+":"+ a.oid;});
          //
          //   $window.bimSurfer.setVisibility({ids: coverings, visible: false });
          //   $log.log('Coverings hide '+coverings.length);
          // });
          $window.bimSurfer.reset({visible: true});
          this.clearSelection();
          $window.bimSurfer.setVisibility({types: ["IfcCovering"], visible: false});

          $window.bimSurfer.viewer.setCamera({
            type: "persp",
            eye: [60, 30, 130],
            target: [45, 29, 8],
            up: [0.86, 0.02, 0.5]
          });
        } catch (err) {
        }
      };
      this.resetReverseCamera = function () {
        try {
          $window.bimSurfer.reset({visibility: true});
          $window.bimSurfer.viewer.setSelection({clear: true});
          $window.bimSurfer.setVisibility({
            types: ["IfcDoor", "IfcPlate", "IfcSlab", "IfcFurnishingElement", "IfcSpace"],
            visible: false
          });
          $window.bimSurfer.setVisibility({types: ["IfcCovering", "IfcWallStandardCase"], visible: true});
          $window.bimSurfer.viewer.setCamera({
            eye: [75, 30, -111],
            target: [45, 29, 8],
            up: [0.86, 0.02, -0.5]
          });
        } catch (err) {
        }
      };
      this.getDataObjectByGuid = function (guid) {
        var deferred = $q.defer();
        $http.post(bim_address + '/json', JSON.stringify({
          token: coreService.get_user().token,
          request: {
            interface: 'LowLevelInterface',
            method: 'getDataObjectByGuid',
            parameters: {
              roid: coreService.get_user().roid,
              packageName: "ifc2x3tc1",
              guid: guid
            }
          }
        })).then(function (response) {
          if (response.data.response === undefined) {
            deferred.reject('Error: ');
          }
          if ('exception' in response.data.response) {
            deferred.reject('Error: ' + response.data.response.exception.message);
          } else {
            var res = response.data.response.result.values;
            var result = $filter('filter')(res, {fieldName: "LongName"});
            if (result.length === 0)
              result = $filter('filter')(res, {fieldName: "Name"});
            if (result.length !== 0)
              deferred.resolve(result[0].stringValue);
            else
              deferred.reject('No name found:\t' + guid);
          }
        });
        return deferred.promise;
      };

      this.getDataObjectsByType = function (val, flat) {
        var deferred = $q.defer();

        if (angular.isUndefined(flat)) flat = true;
        $http.post(bim_address + '/json', JSON.stringify({
          token: coreService.get_user().token,
          request: {
            interface: 'LowLevelInterface',
            method: 'getDataObjectsByType',
            parameters: {
              roid: coreService.get_user().roid,
              packageName: "ifc2x3tc1",
              className: val,
              flat: flat
            }
          }
        })).then(function (response) {

          if (response.data.response === undefined) {
            deferred.reject('Error: ');
          }
          if ('exception' in response.data.response) {
            deferred.reject('Error: ' + response.data.response.exception.message);
          } else {
            deferred.resolve(response.data.response.result);
          }
        });
        return deferred.promise;
      };
      $window.BimServerClient = undefined;
      this.resizeMap = function (mode) {
        if (angular.isUndefined($document) && $document.length === 0)
          return;
        var minHeight = $window.Math.min($window.outerHeight, $window.innerHeight);
        var minWidth = $window.Math.min($window.outerWidth, $window.innerWidth);
        if (minWidth > 1260) {
          minHeight = $window.Math.min(minHeight, 600);
        }
        switch (mode) {
          case "xs":
            $document[0].getElementById('canvas').style.height = $window.Math.min(minHeight - 303, minWidth - 60) + "px";
            break;
          case "sm":
            $document[0].getElementById('canvas').style.height = $window.Math.min(minHeight - 301, minWidth - 60) + "px";
            break;
          case "md":
            $document[0].getElementById('canvas').style.height = $window.Math.min(minHeight - 281, minWidth - 60) + "px";

            break;
          default:
            $document[0].getElementById('canvas').style.height = $window.Math.min(minHeight - 231, minWidth - 60) + "px";
            break;
        }
      };
      this.load = function (funcSetGuid) {
        var selection_change_callback = function () {
          $window.bimSurfer.on("selection-changed", function (selected) {
            if (selected.objects.length === 0) {
              // coreService.User.message.sourceGuid = null;
              if (angular.isDefined(funcSetGuid))
                funcSetGuid(null);

              return;
            }
            $window.bimSurfer.viewFit({ids: selected.objects, animate: true});
            var sel = bimSurfer.toGuid([selected.objects[0].split(':')[1]])[0];
            $log.log(sel);
            if (angular.isDefined(funcSetGuid))
              funcSetGuid(sel);
            // coreService.User.message.sourceGuid = sel;
          });
        };
        var deferred = $q.defer();
        if (angular.isDefined($window.bimSurfer)) {
          var dd = document.getElementById('viewerContainer');
          var canvas = xeogl.scenes[1].canvas.canvas;
          if (dd.childElementCount > 0) {
            dd.removeChild(dd.children.canvas);
          }
          dd.appendChild(canvas);
          vm.resizeMap();
          selection_change_callback();

          deferred.resolve($window.bimSurfer);
        } else {
          eval('import("' + bim_address + '/apps/bimserverjavascriptapi/bimserverclient.js?crossorigin=")').then(function (bimserverapi) {
            require(["bimsurfer/src/BimSurfer", "bimsurfer/src/BimServerModelLoader"],
              function (BimSurfer, BimServerModelLoader) {

                function processBimSurferModel(bimSurferModel) {
                  bimSurferModel.getTree().then(function (tree) {
                    coreService.set_model(tree);
                  });
                }

                $window.BimServerClient = bimserverapi.default;
                $window.BimServerApiPromise = bimserverapi.BimServerApiPromise;
                var bimSurfer = new BimSurfer({
                  domNode: 'viewerContainer'
                });
                $window.bimSurfer = bimSurfer;
                var token = coreService.User.token;

                bimSurfer.on("loading-finished", function () {
                  $window.bimSurfer.viewer.saveReset();
                  vm.resetCamera();
                });
                bimSurfer.on("loading-started", function () {
                });

                selection_change_callback();
                var bimServerClient = $window.bimServerClient;

                if (bimServerClient === undefined) {
                  // noinspection JSUnresolvedFunction
                  bimServerClient = new $window.BimServerClient(bim_address, null);
                  bimServerClient.init(function () {
                    // noinspection JSUnresolvedFunction
                    bimServerClient.setToken(token, function () {
                      // Create a model loader, this one is able to load models from a BIMserver and therefore can have BIMserver specific calls
                      var modelLoader = new BimServerModelLoader(bimServerClient, bimSurfer);
                      var models = {}; // roid -> Model
                      // For this example, we'll fetch all the latest revisions of all the subprojects of the main project
                      var poid = coreService.User.poid;

                      var nrProjects;

                      function loadModels(models, totalBounds) {
                        var center = [
                          (totalBounds.min[0] + totalBounds.max[0]) / 2,
                          (totalBounds.min[1] + totalBounds.max[1]) / 2,
                          (totalBounds.min[2] + totalBounds.max[2]) / 2
                        ];

                        var globalTransformationMatrix = [
                          1, 0, 0, 0,
                          0, 1, 0, 0,
                          0, 0, 1, 0,
                          -center[0], -center[1], -center[2], 1
                        ];
                        $log.log(totalBounds, models);
                        if (angular.isDefined(coreService.Model.model)) {
                          modelLoader.setGlobalTransformationMatrix(globalTransformationMatrix);
                          modelLoader.loadFullModel2(coreService.Model.model);
                          processBimSurferModel(coreService.Model.model);
                          $rootScope.$broadcast('bimSurferLoaded');
                        } else
                          for (var roid in models) {
                            // noinspection JSUnfilteredForInLoop
                            var model = models[roid];
                            modelLoader.setGlobalTransformationMatrix(globalTransformationMatrix);
                            modelLoader.loadFullModel(model).then(function (bimSurferModel) {
                              coreService.Model.model = bimSurferModel;
                              processBimSurferModel(bimSurferModel);
                              $rootScope.$broadcast('bimSurferLoaded');
                            });
                            break;
                          }
                      }

                      bimServerClient.call("ServiceInterface", "getAllRelatedProjects", {poid: poid}, function (projects) {
                        nrProjects = projects.length;

                        var totalBounds = {
                          min: [Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE],
                          max: [-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE]
                        };

                        projects.forEach(function (project) {
                          if (project.lastRevisionId !== -1 && (project.nrSubProjects === 0 || project.oid !== poid)) {
                            // noinspection JSUnresolvedFunction
                            bimServerClient.getModel(project.oid, project.lastRevisionId, project.schema, false, function (model) {
                              models[project.lastRevisionId] = model;

                              bimServerClient.call("ServiceInterface", "getModelMinBounds", {roid: project.lastRevisionId}, function (minBounds) {
                                bimServerClient.call("ServiceInterface", "getModelMaxBounds", {roid: project.lastRevisionId}, function (maxBounds) {
                                  if (minBounds.x < totalBounds.min[0]) {
                                    totalBounds.min[0] = minBounds.x;
                                  }
                                  if (minBounds.y < totalBounds.min[1]) {
                                    totalBounds.min[1] = minBounds.y;
                                  }
                                  if (minBounds.z < totalBounds.min[2]) {
                                    totalBounds.min[2] = minBounds.z;
                                  }
                                  if (maxBounds.x > totalBounds.max[0]) {
                                    totalBounds.max[0] = maxBounds.x;
                                  }
                                  if (maxBounds.y > totalBounds.max[1]) {
                                    totalBounds.max[1] = maxBounds.y;
                                  }
                                  if (maxBounds.z > totalBounds.max[2]) {
                                    totalBounds.max[2] = maxBounds.z;
                                  }
                                  nrProjects--;
                                  if (nrProjects === 0) {
                                    loadModels(models, totalBounds);
                                  }
                                });
                              });
                            });
                          } else {
                            nrProjects--;
                            if (nrProjects === 0) {
                              loadModels(models, totalBounds);
                            }
                          }
                        });
                      });
                    });
                  });
                }
                vm.resizeMap();
                deferred.resolve(bimSurfer);
              });
          });
        }
        return deferred.promise;
      };

      this._spaces = [];
      this.loadSpaces = function () {
        var deferred = $q.defer();
        if (!coreService.is_logged_in())
          deferred.reject('Please login');
        else if (vm._spaces.length !== 0)
          deferred.resolve(vm._spaces);
        else
          this.getDataObjectsByType('IfcSpace').then(function (data) {
            vm._spaces = data.map(function (a) {
              return {id: a.guid, name: a.name}
            });
            deferred.resolve(vm._spaces);
          });
        return deferred.promise;
      };

      this._relations = [];
      this.toStringValues = function (data) {
        var nameDic = {
          'IfcFlowTerminal': {
            'musluk': 'Musluk',
            'klozet': 'Klozet', 'light': 'Aydınlatma', 'toilet': 'Klozet',
            'm_supply grille': 'Hava Kanalı'
          },
          'IfcFurnishingElement': {
            'table': 'Masa',
            'armchair': 'Koltuk',
            'hotdesk1': 'Dolap',
            'chair': 'Sandalye',
            'cabinet': 'Dolap',
            'm_counter': 'Dolap',
            'contemporary': 'Koltuk',
            'shelving': 'Raf',
            'tezgah': 'Tezgah'
          },
          'IfcDoor': {
            'door': 'Kapı',
            'm_Single': 'Kapı',
            'double_glass': 'Cam Kapı'
          }
        };
        var defaultNameDic = {
          'IfcSlab': 'Zemin Döşemesi',
          'IfcCovering': 'Asma Tavan',
          'IfcFlowTerminal': 'Tesisat',
          'IfcFurnishingElement': 'Mobilya',
          'IfcDoor': 'Kapı',
          'IfcCurtainWall': 'Pencere',
          'IfcPlate': 'Pencere'
        };
        var name = $window.bimSurfer.toName([data.guid])[0].toLowerCase();
        var typeName = $window.bimSurfer.toType([data.guid])[0];
        var res = '';

        if (angular.isDefined(nameDic[typeName])) {
          for (var key in nameDic[typeName]) {
            if (name.includes(key)) {
              res += nameDic[typeName][key];
              break;
            }
          }
        }
        if (res === '') {
          if (angular.isDefined(defaultNameDic[typeName]))
            res += defaultNameDic[typeName];
          else if (typeName === 'IfcSpace')
            res += name;
          else
            res += data.guid;
        }
        return res;
      };
      this.loadRelatedElement = function () {
        var deferred = $q.defer();

        if (!coreService.is_logged_in())
          deferred.reject('Please login');
        else if (vm._relations.length !== 0)
          deferred.resolve(vm._relations);
        else
          vm.getDataObjectsByType('IfcRelContainedInSpatialStructure', false).then(function (data) {
            var relatedElements = data.map(function (x) {
              return x.values.filter(function (y) {
                return y.fieldName === "RelatedElements"
              })[0].values
            });
            var relatingStructures = data.flatMap(function (x) {
              return x.values.filter(function (y) {
                return y.fieldName === "RelatingStructure"
              })
            });
            for (var i = 0; i < relatingStructures.length; i++) {

              var items = relatedElements[i].flatMap(function (x) {
                var res = {
                  guid: x.guid, typeName: x.typeName,
                  parentTypeName: relatingStructures[i].typeName,
                  parentGuid: relatingStructures[i].guid
                };
                if (res.parentTypeName === 'IfcSpace') {
                  res.parentName = vm._spaces.filter(function (x) {
                    return x.id === res.parentGuid
                  })[0].name;
                } else if (res.parentTypeName === 'IfcBuildingStorey') {
                  res.parentName = "IfcBuildingStorey";
                }
                return res;
              });
              vm._relations.push.apply(vm._relations, items);
            }

            deferred.resolve(vm._relations);
          });
        return deferred.promise;
      };

      this.loadRelatedElementByGuid = function (guid) {
        var deferred = $q.defer();
        vm.loadSpaces().then(function () {

          vm.loadRelatedElement().then(function (data) {

            var res = data.filter(function (x) {
              return x.guid === guid
            });
            if (res.length === 0) {
              res = {guid: guid};
              deferred.resolve(res);
            } else
              deferred.resolve(res[0]);
          });
        });

        return deferred.promise;
      };
      this.sendComplaint = function (complaint) {
        var deviceType = 'PC';
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
          deviceType = 'Mobile';
        var arg = {
          criteria: complaint.criteria,
          dimension: complaint.dimension,
          indicator: complaint.indicator,
          location: complaint.location,
          source: complaint.source,
          message: complaint.message,
          time: complaint.time,
          response_time: complaint.response_time,
          type: complaint.type,
          user: coreService.User,
          deviceType: deviceType,
          creationTime: moment().format('YYYY-MM-DD HH:mm')
        };
        var deferred = $q.defer();
        $http.get(bim_complaint_address + 'push?complaint=' + JSON.stringify(arg), {withCredentials: false}).then(function (response) {
          if (angular.isDefined(response.data) && response.data != null && angular.isDefined(response.data.success) && response.data.success != null && response.data.success === true)
            deferred.resolve(response);
          else
            deferred.reject(response.status);
        }).catch(function (err) {
          // handle errors
          debugger
        });
        return deferred.promise;
      };
      this.sendUpdateComplaint = function (complaint) {
        var deviceType = 'PC';
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
          deviceType = 'Mobile';
        var arg = {
          index: complaint.index,
          fm_technician: complaint.fm_technician,
          fm_message: complaint.fm_message,
          fm_user: coreService.User,
          response_time: complaint.response_time,
          status: complaint.status,
          lastModificationTime: moment().format('YYYY-MM-DD HH:mm'),
          criteria: complaint.criteria,
          dimension: complaint.dimension,
          indicator: complaint.indicator,
          location: complaint.location,
          source: complaint.source,
          message: complaint.message,
          time: complaint.time,
          type: complaint.type,
          user: complaint.user,
          deviceType: complaint.deviceType,
          creationTime: moment().format('YYYY-MM-DD HH:mm'),
        };
        var deferred = $q.defer();
        $http.post(bim_complaint_address + 'update?complaint=' + JSON.stringify(arg), {withCredentials: false}).then(function (response) {
          if (angular.isDefined(response.data) && response.data != null && angular.isDefined(response.data.success) && response.data.success != null && response.data.success === true)
            deferred.resolve(response);
          else
            deferred.reject(response.status);
        }).catch(function (err) {
          // handle errors
          debugger
        });
        return deferred.promise;
      };
      this.getOpenComplaints = function (query) {
        return this.getComplaints(query, 'waiting');
      };
      this.getComplaints = function (query, type) {
        var deferred = $q.defer();
        var type_str = '';
        if (angular.isDefined(type) && type !== '')
          type_str = '?type=' + type;

        if (!angular.isDefined(query)) {
          $http.get(bim_complaint_address + 'get_datas' + type_str, {withCredentials: false}).then(function (response) {
            if (angular.isDefined(response.data) && response.data != null && angular.isDefined(response.data.success) && response.data.success != null && response.data.success === true)
              deferred.resolve(response.data);
            else
              deferred.reject(response.status);
          }).catch(function (err) {
            // handle errors
            debugger
          });
        } else {
          $http.get(bim_complaint_address + 'get_datas' + type_str, {withCredentials: false}).then(function (response) {
            if (angular.isDefined(response.data) && response.data != null && angular.isDefined(response.data.success) && response.data.success != null && response.data.success === true)
              deferred.resolve(response.data);
            else
              deferred.reject(response.status);
          }).catch(function (err) {
            // handle errors
            debugger
          });
        }
        return deferred.promise;
      };
      this.str2 = function (type, data) {
        var deferred = $q.defer();
        if (angular.isDefined(data) && data !== '')
          this.str(type, data).then(function (item) {
            return deferred.resolve(item);
          });
        else
          deferred.resolve('');
        return deferred.promise;
      };
      this.str = function (type, data) {
        var deferred = $q.defer();
        if (!angular.isDefined($window.bimSurfer)) {
          this.load()
        }
        switch (type) {
          case 'loc':
            if (!angular.isDefined(data))
              data = coreService.Complaint.location;
            if (angular.isDefined(data)) {
              if (data.parentTypeName === 'IfcSpace') {
                this.loadSpaces().then(function (spaces) {
                  var spaceName = spaces.filter(function (x) {
                    return x.id === data.parentGuid
                  })[0].name;
                  // noinspection JSPotentiallyInvalidUsageOfThis

                  deferred.resolve(spaceName + ' - ' + vm.toStringValues(data));
                });
              } else
                deferred.resolve('Bina - ' + vm.toStringValues(data));
            } else
              deferred.resolve('');
            break;
          case 'sour':
            if (!angular.isDefined(data))
              data = coreService.Complaint.source;
            if (angular.isDefined(data)) {
              if (data.parentTypeName === 'IfcSpace') {
                this.loadSpaces().then(function (spaces) {
                  var spaceName = spaces.filter(function (x) {
                    return x.id === data.parentGuid
                  })[0].name;
                  // noinspection JSPotentiallyInvalidUsageOfThis
                  // deferred.resolve();
                  deferred.resolve([spaceName + ' - ' + vm.toStringValues(data), 'Mekan - ' + spaceName]);
                });
              } else
                deferred.resolve(['Mekan - ' + vm.toStringValues(data), 'Mekan - ' + vm.toStringValues(data)]);
            } else
              deferred.resolve(['', '']);
            break;
        }
        return deferred.promise;
      }
    }
  }

)();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .service('utilsService', UtilsService);


  /** @ngInject */
  function UtilsService(rw_orders, $log, $filter) {
    this.get_complaint_from_indicator = function (indicator) {
      var p_d = rw_orders.rw_map.filter(function (d) {
        return d.criterias.some(function (c) {
          return c.indicators.some(function (i) {
            return i === indicator
          })
        })
      })[0];

      var p_c = p_d.criterias.filter(function (c) {
        return c.indicators.some(function (i) {
          return i === indicator
        })
      })[0];

      return {dimension: p_d.name, criteria: p_c.name, indicator: indicator};
    };
    this.get_dimensions = function () {
      return rw_orders.rw_map.map(function (a) {
        return {id: a.name, name: $filter('translate')(a.name)}
      });
    };
    this.get_criterias = function (p_dimension) {
      return rw_orders.rw_map.filter(function (a) {
        return a.name === p_dimension
      })[0].criterias.map(function (a) {
        return {id: a.name, name: $filter('translate')(a.name)}
      });
    };
    this.get_indicators = function (p_dimension, p_criteria) {
      return rw_orders.rw_map.filter(function (a) {
        return a.name === p_dimension
      })[0].criterias.filter(function (a) {
        return a.name === p_criteria
      })[0].indicators.map(function (a) {
        return {id: a, name: $filter('translate')(a)}
      });
    };
    this.parse_orders = function (p_key) {
      var orderClass = new this.OrderClass();
      orderClass.parse(rw_orders.orders[p_key]);
      return orderClass;
    };

    this.get_order_names = function () {
      return Object.keys(rw_orders.orders)
    };

    this.OrderClass = function () {

    };
    this.OrderClass.prototype.clean = function () {
      this.orders = undefined;
      this.building = undefined;
      this.floor = undefined;
      this.room = undefined;
      this.location = undefined;
      this.frontage = undefined;
      this.element_type = undefined;
      this.related_element = undefined;
      this.source_location = undefined;
      this.time = undefined;
    };
    this.OrderClass.prototype.parse = function (orders) {
      this.clean();
      this.orders = orders;
      var t_array = this.orders.split('_');
      if (t_array.length !== 9) {
        $log.log('Wrong order\t' + this.orders);
        return undefined;
      }
      for (var i = 0; i < t_array.length; i++) {
        if (t_array[i] === '') continue;
        var t_item = t_array[i].replace('x', 'must').replace('o', 'may');
        switch (i) {
          case 0:
            this.building = t_item;
            break;
          case 1:
            this.floor = t_item;
            break;
          case 2:
            this.room = t_item;
            break;
          case 3:
            this.location = t_item;
            break;
          case 4:
            this.frontage = t_item;
            break;
          case 5:
            this.element_type = t_item;
            break;
          case 6:
            this.related_element = t_item;
            break;
          case 7:
            this.source_location = t_item;
            break;
          case 8:
            this.time = t_item;
            break;
        }
      }
    };


    this.ComplaintClass = function () {
    };

    this.ComplaintClass.prototype.getAllIndicators = function () {
      return Object.keys(rw_orders.orders).map(function (a) {
        return {id: a, name: $filter('translate')(a)}
      });
    };
    this.ComplaintClass.prototype.getComplaintDataByIndicator = function (indicator) {
      var i = 0;
      for (i = 0; i < rw_orders.rw_map.length; i++) {
        var dim_item = rw_orders.rw_map[i];
        var dimension = dim_item.name;
        var j = 0;
        for (j = 0; j < dim_item.criterias.length; j++) {
          var cri_item = dim_item.criterias[j];
          var criteria = cri_item.name;
          var k = 0;
          for (k = 0; k < cri_item.indicators.length; k++) {
            var indi_item = cri_item.indicators[k];
            if (indi_item === indicator)
              return {indicator: indicator, criteria: criteria, dimension: dimension};
          }
        }
      }
      return null;
    };

    this._complaintClass = new this.ComplaintClass();
    this.getComplaint = function () {
      return this._complaintClass;
    };
  }
})
();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('MainController', MainController)

  ;

  /** @ngInject */
  function MainController($scope, $location, $state, coreService) {
    var vm = this;
    coreService.get_user();
    if (angular.isDefined(coreService.User) && coreService.User !== '' && coreService.User != null && angular.isDefined(window.location.search) && window.location.search !== "") {
      if (window.location.search.split('=')[0] === '?Location') {
        coreService.User.location = window.location.search.split('=')[1];
        coreService.set_user();
      }
    }
    vm.openMenu = function ($mdMenu, ev) {
      $mdMenu.open(ev);
    };
    // debugger;
    // var qs = $location.search();
    vm.submitBtn = function (cmd) {
      switch (cmd) {
        case "rw_enter":
          $state.go('rw_new_enter');
          break;
        case "rw_list":
          $state.go('rw_list');
          break;
        case "rw_settings":
          //$state.go('rw_settings');
          break;
        case "rw_about":
          //$state.go('rw_about');
          break;
        case "rw_logout":
          coreService.logout_user();
          $state.go('login');
          break;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .service('loginService', LoginService);

  /** @ngInject */
  function LoginService($http, $q, bim_address, coreService) {
    //   method: 'POST',
    //   url: ,
    //   headers: {
    //     'Content-Type': 'text/plain'
    //   }
    // };
    this.auth = function (username, password) {
      var deferred = $q.defer();
      $http.post(bim_address + '/json', JSON.stringify({
        request: {
          interface: 'AuthInterface',
          method: 'login',
          parameters: {username: username, password: password}
        }
      })).then(function (response) {
          if ('exception' in response.data.response) {
            deferred.reject('Error: ' + response.data.response.exception.message);
          }
          else {
            coreService.get_user().username = username;
            coreService.get_user().token = response.data.response.result;
            deferred.resolve('Success');
          }
        },
        function () {
          deferred.reject('Error: Connection Error');
        });
      return deferred.promise;
    };

    this.updatePoid = function () {
      var deferred = $q.defer();
      $http.post(bim_address + '/json', JSON.stringify({
        token: coreService.get_user().token,
        request: {
          interface: 'ServiceInterface',
          method: 'getAllProjects',
          parameters: {onlyTopLevel: false, onlyActive: true}
        }
      })).then(function (response) {
          if ('exception' in response.data.response) {
            deferred.reject('Error: ' + response.data.response.exception.message);
          } else {
            var projects = $(response.data.response.result).filter(function (i, project) {
              return project.state === "ACTIVE" && project.name === "Rateworkspace";
            });
            if (projects.length === 0) {
              deferred.reject('Error: System Error');
            }
            else {
              coreService.get_user().poid = projects[0].oid;
              deferred.resolve('Success');
            }
          }
        },
        function () {
          deferred.reject('Error: Connection Error');
        });
      return deferred.promise;
    };
    this.revisionUpdate = function (getLastRev) {
      var deferred = $q.defer();
      if (coreService.get_user().poid != null)
        $http.post(bim_address + '/json', JSON.stringify({
          token: coreService.get_user().token,
          request: {
            interface: 'ServiceInterface',
            method: 'getAllRevisionsOfProject',
            parameters: {poid: coreService.get_user().poid}
          }
        })).then(
          function (response) {
            if ('exception' in response.data.response) {
              deferred.reject('Error: ' + response.data.response.exception.message);
            }
            else {
              var revisions = $(response.data.response.result).sort(function (r1, r2) {
                return r1.id > r2.id;
              });
              if (revisions.length === 0) {
                return deferred.reject('Error: System Error');
              }
              if (angular.isUndefined(getLastRev) || getLastRev == null || getLastRev === true || getLastRev === 'Success')
                coreService.get_user().roid = revisions[0].oid;
              else
                coreService.get_user().roid = revisions[revisions.length - 1].oid;
              deferred.resolve('Success');
            }
          },
          function () {
            return deferred.reject('Error: Connection Error');
          }
        );
      return deferred.promise;
    };


    this.login = function (username, password) {
      return this.auth(username, password)
        .then(this.updatePoid)
        .then(this.revisionUpdate)
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state,$scope, loginService,coreService,toastr,$log,$stateParams) {
    var vm = this;
    vm.loginModel = {
      username: '',
      password: ''
    };

    coreService.logout_user();
    vm.submitForm = function () {
      $log.log(vm.loginModel);
      loginService.login(vm.loginModel.username, vm.loginModel.password).then(function () {
        $log.log(coreService.get_user());
        if (angular.isDefined($stateParams.sp)&&$stateParams.sp!=null)
          coreService.User.location=$stateParams.sp;
        coreService.set_user();
        $state.go('main', {user:coreService.get_user()});
      }).catch(function (response) {
        $log.error(response);
        toastr.error(response, 'Hata!');
      }).finally(function () {
        $log.log("login finally finished ");
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1533061843448;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')

    // .constant('bim_address', 'http://160.75.154.10:8082')
    .service('coreService', CoreService);

  /** @ngInject */
  function CoreService($cookies,$location,$timeout,$state) {
    this.Model = {};
    this.set_model = function (tree) {
      var flatten2 = function (n) {
        var li = {};
        var f = function (n) {
          if (angular.isUndefined(n)) return;
          li[n.id] = {'guid': n.guid, 'parent': n.parent};
          (n.children || []).forEach(f);
        };
        f(n);
        return li;
      };
      this.Model.All = flatten2(tree);
      this.Model.Tree = tree;
    };
    this.User = null;
    this.Complaint = {};
    this.set_user = function () {
      $cookies.put('rw_user', JSON.stringify(this.get_user()));
    };
    this.logout_user = function () {
      $cookies.remove('rw_user');
      this.User = null;
      this.get_user();
    };
    this.get_user = function () {
      if (this.User == null) {
        var cUser = $cookies.get('rw_user');
        if (angular.isDefined(cUser) && cUser != null)
          this.User = JSON.parse(cUser);
        else
          this.User = null;
      }
      if (this.User == null) {
        this.User = {
          username: null,
          token: null,
          poid: null,
          roid: null
        };
      }
      return this.User;
    };

    function _v(value, c_m) {
      if (angular.isDefined(c_m))
        return angular.isDefined(value) && value != null && value === c_m;
      else
        return angular.isDefined(value) && value != null;
    }

    this.check_complaint = function (value_type) {
      if (angular.isUndefined(this.Complaint.indicator) || this.Complaint.indicator == null ||
        (this.Complaint.type !== "list" &&
          (angular.isUndefined(this.Complaint.orderObj) || this.Complaint.orderObj == null)))
        return false;
      switch (value_type) {
        case 'room':
          return _v(this.Complaint.orderObj.room, 'must') && (!_v(this.Complaint.location));// || !(['IfcSlab', 'IfcSpace'].indexOf(this.Complaint.location.typeName)!==-1)
        case 'location':
          return _v(this.Complaint.orderObj.location, 'must') && !_v(this.Complaint.location);
        case 'element_type':
          return _v(this.Complaint.orderObj.element_type, 'must') && !_v(this.Complaint.source);
        case 'related_element':
          return _v(this.Complaint.orderObj.related_element, 'must') && !_v(this.Complaint.source);
        case 'source_location':
          return _v(this.Complaint.orderObj.source_location, 'must') && !_v(this.Complaint.source);
        case 'time':
          return _v(this.Complaint.orderObj.time, 'must') && !_v(this.Complaint.time);
      }
      return false;
    };
    this.complaint_init = function (dimension, criteria, indicator, type, custom) {
      this.Complaint = {};
      this.Complaint.dimension = dimension;
      this.Complaint.criteria = criteria;
      this.Complaint.indicator = indicator;
      this.Complaint.type = type;// search,list,write
      this.Complaint.custom = custom;
    };
    this.complaint_reset = function () {
      this.Complaint = {};
      this.Complaint.dimension = null;
      this.Complaint.criteria = null;
      this.Complaint.indicator = null;
      this.Complaint.type = null;// search,list,write
      this.Complaint.custom = null;
      this.Complaint.time = null;
      this.Complaint.response_time = null;
      this.Complaint.message = null;
      this.Complaint.location = null;
      this.Complaint.source = null;
    };
    this.is_logged_in = function () {
      var tUser = this.get_user();
      return !(angular.isUndefined(tUser) || tUser == null ||
        angular.isUndefined(tUser.username) || tUser.username == null ||
        angular.isUndefined(tUser.token) || tUser.token == null ||
        angular.isUndefined(tUser.poid) || tUser.poid == null ||
        angular.isUndefined(tUser.roid) || tUser.roid == null);
    };

    this.check_logged_in=function (isAdmin) {
      if ((!this.is_logged_in() ||
        (angular.isDefined(isAdmin) && isAdmin && angular.isDefined(this.get_user()) &&
          this.get_user().username !== 'rateworkspace@gmail.com')) && $location.path() !== '/') {
        if (angular.isDefined(window.location.search) && window.location.search !== "") {
          if (window.location.search.split('=')[0] === '?Location') {
            $timeout(function () {
              if (angular.isDefined(isAdmin) && isAdmin)
                $state.go('admin-login');
              else
                $state.go('login', {sp: window.location.search.split('=')[1]});
            });
            return;
          }
        }
        $timeout(function () {
          if (angular.isDefined(isAdmin) && isAdmin)
            $state.go('admin-login');
          else
            $state.go('login');
        },200)
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, mdcDefaultParams, $http, $state, coreService, $location, $timeout, $window) {
    $log.debug('runBlock end');
    var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
      $log.log('Translation completed (before)');
    });
    $rootScope.$on('$destroy', function () {
      translateChangeSuccess();
    });

    function checkLogged(isAdmin) {
      coreService.check_logged_in(isAdmin);
    }

    $rootScope.$watch(function () {
      return $state.$current.name
    }, function (newVal, oldVal) {
      //do something with values
      switch (newVal) {
        case 'main':
        case 'rw_new_enter':
        case 'rw_location':
        case 'rw_source':
        case 'rw_time':
        case 'rw_message':
        case 'rw_preview':
          checkLogged();
          break;
        case 'ad_main':
        case 'admin-login':
        case 'admin-complaint-waiting':
        case 'admin-complaints':
        case 'admin-complaints-filter':
        case 'admin-complaints-statistic':
          checkLogged(true);
          break;
        default:
          break;
      }
      if (angular.isDefined($window.bimSurfer) && $window.bimSurfer !== null)
        if (newVal === 'admin-complaints-filter') {
          bimSurfer.setLights([{
            type: "dir",
            params: {
              dir: [0.0, 0.0, -1.0],
              color: [0.0, .4, .4],
              intensity: 0.5,
              space: "view"
            }
          }, {
            type: "ambient",
            params: {
              color: [0.65, 0.65, 0.75],
              intensity: 0.5
            }
          }]);
        } else {
          $window.bimSurfer.setVisibility({types: ["IfcSpace"], visible: false});
          $window.bimSurfer.setLights([
            {
              type: "ambient",
              params: {
                color: [0.65, 0.65, 0.75],
                intensity: 1
              }
            },
            {
              type: "dir",
              params: {
                dir: [0.0, 0.0, -1.0],
                color: [1.0, 1.0, 1.0],
                intensity: 1.0,
                space: "view"
              }
            }
          ]);
        }
    });


    mdcDefaultParams({lang: 'tr', cancelText: 'iptal', todayText: 'bugün', okText: 'tamam'});
    // Sends this header with any AJAX request
    // $http.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
  }


})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('login', {
        url: '/',
        params: {
          sp: null,
        },
        templateUrl: 'app/login/login.tpl.html',
        controller: 'LoginController',
        controllerAs: 'vm'
      })
      .state('main', {
        url: '/main',
        params: {
          sp: null,
        },
        templateUrl: 'app/main/main.tpl.html',
        controller: 'MainController',
        controllerAs: 'vm'
      })
      .state('rw_new_enter', {
        url: '/enter',
        templateUrl: 'app/main/modules/complaintInsert/complaintInsert.tpl.html',
        controller: 'ComplaintInsertController',
        controllerAs: 'vm'
      })
      .state('rw_location', {
        url: '/location',
        templateUrl: 'app/main/modules/complaintLocation/complaintLocation.tpl.html',
        controller: 'ComplaintLocationController',
        controllerAs: 'vm'
      })
      .state('rw_source', {
        url: '/source',
        templateUrl: 'app/main/modules/complaintSource/complaintSource.tpl.html',
        controller: 'ComplaintSourceController',
        controllerAs: 'vm'
      })
      .state('rw_time', {
        url: '/time',
        templateUrl: 'app/main/modules/complaintTime/complaintTime.tpl.html',
        controller: 'ComplaintTimeController',
        controllerAs: 'vm'
      })
      .state('rw_message', {
        url: '/message',
        templateUrl: 'app/main/modules/complaintMessage/complaintMessage.tpl.html',
        controller: 'ComplaintMessageController',
        controllerAs: 'vm'
      })
      .state('rw_preview', {
        url: '/preview',
        templateUrl: 'app/main/modules/complaintPreview/complaintPreview.tpl.html',
        controller: 'ComplaintPreviewController',
        controllerAs: 'vm'
      })

      .state('ad_main', {
        url: '/admin-main',
        templateUrl: 'app/admin/modules/main/main.tpl.html',
        controller: 'AdminMainController',
        controllerAs: 'vm'
      })
      .state('admin-login', {
        url: '/admin-login',
        params: {
          sp: null,
        },
        templateUrl: 'app/admin/modules/login/admin.login.tpl.html',
        controller: 'AdminLoginController',
        controllerAs: 'vm'
      })
      .state('admin-complaint-waiting', {
        url: '/admin-complaint-waiting',
        templateUrl: 'app/admin/modules/complaint/waiting/admin.complaint.waiting.tpl.html',
        controller: 'AdminComplaintWaitingController',
        controllerAs: 'vm'
      })
      .state('admin-complaints', {
        url: '/admin-complaints',
        templateUrl: 'app/admin/modules/complaint/list/admin.complaint.tpl.html',
        controller: 'AdminComplaintListController',
        controllerAs: 'vm'
      })
      .state('admin-complaints-filter', {
        url: '/admin-complaints-filter',
        templateUrl: 'app/admin/modules/complaint/filter_list/admin.complaint.tpl.html',
        controller: 'AdminComplaintFilterListController',
        controllerAs: 'vm'
      })
      .state('admin-complaints-statistic', {
        url: '/admin-complaints-statistic',
        templateUrl: 'app/admin/modules/complaint/statistic/admin.complaint.statistic.tpl.html',
        controller: 'AdminComplaintStatisticController',
        controllerAs: 'vm'
      })
    // .state('home', {
    //   url: '/home',
    //   templateUrl: 'app/home/home.html',
    //   controller: 'HomeController',
    //   controllerAs: 'vm'
    // })
    ;

    $urlRouterProvider.otherwise('/');

  }

})();

/* global malarkey:false */
(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    //.constant('bim_address', 'http://localhost:8082')
    .constant('bim_address', 'http://160.75.154.10:8082')
    //.constant('bim_complaint_address', 'http://127.0.0.1:8083/')
    .constant('bim_complaint_address', 'http://160.75.154.10:8083/')
    .constant('malarkey', malarkey)
    // .constant('moment', moment)
    .constant('rw_orders', {
      "orders": {
        "ln_very_cold": "x_o_o_o_____x",
        "ln_very_warm": "x_o_o_o_____x",
        "ln_unbalanced_temp": "x_o_o_o_____x",
        "ln_air_leakage": "x_x_x_x_x_x_x__",
        "ln_vertical_temp_diff": "x_x_x_o_____x",
        "ln_temp_diff_window_side": "x_x_x_o_o_o_o__x",
        "ln_direct_sun": "x_x_x_x_x_x_x__x",
        "ln_direct_heat_source": "x_x_x_x__x_x__x",
        "ln_v_dry_air": "x_o_o_o__o_o__x",
        "ln_v_humid_air": "x_o_o_o_____x",
        "ln_fast_temp_var": "x_o_o_o_____x",
        "ln_low_temp_var": "x_o_o_o_____x",
        "ln_af_aircondition_units": "x_x_x_x__x_x__x",
        "ln_af_window_door_units": "x_x_x_x__x_x__x",
        "ln_quality_air_ventilation_sys": "x_o_o_o_____x",
        "ln_quality_air_outside": "x_o_o_o_o_o_o__x",
        "ln_not_enough_natural_ventilation": "x_o_o_o_____",
        "ln_odor_outside": "x_o_o_o_o_o_o_o_x",
        "ln_odor_air_pollution": "x_o_o_o_____x",
        "ln_odor_materials": "x_o_o_o__o_o__x",
        "ln_odor_food": "x_o_o_o____o_x",
        "ln_odor_toilets": "x_o_o_o____o_x",
        "ln_odor_humidity": "x_o_o_o____o_x",
        "ln_noise_talking": "x_o_o_o____o_x",
        "ln_noise_footstep": "x_o_o_o____o_x",
        "ln_noise_outside": "x_o_o_o_o_o_o_o_x",
        "ln_noise_venntilation_sys_equip": "x_x_x_x___x__x",
        "ln_noise_lighting_equip": "x_x_x_x___x__x",
        "ln_noise_office_equip": "x_x_x_x__x_x__x",
        "ln_noise_furniture_door": "x_x_x_x__x_x__",
        "ln_echo_work_env": "x_x_x_o_____",
        "ln_echo_meeting_room": "x_x_x______",
        "ln_echo_confer_room": "x_x_x_o_____",
        "ln_echo_social_area": "x_x_x_o_____",
        "ln_no_acoustic_work_env": "x_x_x_o_____",
        "ln_no_acoustic_meet_room": "x_x_x______",
        "ln_not_enough_sunlight": "x_o_o_o_o_o_o__x",
        "ln_quality_work_env": "x_x_x_o___x__",
        "ln_amonut_mytable": "x_x_x_x___x__",
        "ln_shadows_lighting_env": "x_x_x_x___x__",
        "ln_constant_vibration_lighting_env": "x_x_x_o___x__",
        "ln_cause_lighting_env": "x_x_x_x___x__x",
        "ln_cause_direct_sunglight": "x_x_x_x_o__x__x",
        "ln_reflection_onscreens": "x_x_x_x__x_x__x",
        "ln_visual_privacy_work_env": "x_x_x_o_____",
        "ln_visual_privacy_meeting_room": "x_x_x______",
        "ln_mycompscreen_seen": "x_x_x_x_____",
        "ln_notbeing_to_see_outside": "x_x_x_o_____",
        "ln_view_from_mytable": "x_x_x_x_x_x_x__",
        "ln_s_insuff_work_space": "x_x_x_o_____",
        "ln_s_insuff_work_table": "x_x_x_x_____",
        "ln_s_insuff_social_areas": "x_o_o______",
        "ln_s_insuff_meeting_room_common_work_env": "x_o_o______",
        "ln_s_insuff_car_park_areas": "x________",
        "ln_s_insuff_storage_areas": "x_o_o_o__o_o__",
        "ln_s_insuff_restrooms": "x_o_o______",
        "ln_s_insuff_storey_height": "x_o_o_o_____",
        "ln_s_insuff_elevators_escalators": "x_o_____o__",
        "ln_s_insuff_outdoor_areas": "o_o_o______",
        "ln_lp_work_env": "x_o_o_o_____",
        "ln_lp_insuff_directio_signs": "x_o_o_o_____",
        "ln_lp_nointeraction_bet_employ": "x_o_o_o_____",
        "ln_lp_distr_cause_human_circulation": "x_x_x_o_____",
        "ln_lp_distr_cause_other_comp_scre": "x_x_x_x___o__",
        "ln_lp_distr_cause_nonsuitable_work_env_disabled_people": "x_o_o_o_____",
        "ln_indoor_esthetics": "x_o_o_o_____",
        "ln_work_env_not_personalized": "x_o_o_o_____",
        "ln_color_text_work_env": "x_o_o_o_____",
        "ln_disfunctional_work_env": "x_o_o_o_____",
        "ln_insuff_safety_precautions": "x_o_o_o__o_o__",
        "ln_indurable_furnitures_armatures": "x_o_o_o__o_o__",
        "ln_no_indoor_plans": "x_o_o_o_____",
        "ln_comfort_level": "x_o_o_o__o_o__",
        "ln_ergonomic": "x_o_o_o__o_o__",
        "ln_not_customizable": "x_o_o_o__o_o__",
        "ln_not_modular": "x_o_o_o__o_o__",
        "ln_diff_reach_outdoor_areas": "x_o_o_o_____",
        "ln_design_outdoor_areas": "x_o_o_o_____",
        "ln_landscaping": "x_o_o_o_____",
        "ln_by_wind": "x_x_______x",
        "ln_by_vehicles": "x_o_______x",
        "ln_by_users": "x_o_o_o_____x",
        "ln_by_aircond_ventilation_sys": "x_o_o_o___o__",
        "ln_heating_cooling_cannot_controlled": "x_o_o_o___o__",
        "ln_hvac": "x_o_o_o___o__",
        "ln_lighting_equipment_cannot_controlled": "x_o_o_o___o__",
        "ln_sunshade_equipment_cannot_controlled": "x_o_o_o_o_o_o__",
        "ln_natural_ventilation_cannot_controlled": "x_o_o_o_o__o__",
        "ln_water_temp_restroom_cannot_controlled": "x_o_o______",
        "ln_no_ins_book": "x_o_o_o__x_o__",
        "ln_ins_book_not_understand": "x_o_o_o__x_o__",
        "ln_equip_can_not_calibrate_sensitively": "x_o_o_o__x_o__",
        "ln_ventilation_air_cond_services": "x_o_o_o_____",
        "ln_waste_management": "x_o_o_o_____",
        "ln_security": "x_o_o______",
        "ln_cleaning": "x_o_o_o__o_o__",
        "ln_health_safety_procedures": "x_o_o_o_____",
        "ln_pest_control": "x_o_o_o_____",
        "ln_mail_services": "x_o_o______",
        "ln_speed_fm_responces": "x_o_o______",
        "ln_expertise_fm_company_OM": "x________",
        "ln_user_feedback_not_addressed": "x________",
        "ln_annoucement_fm_services": "x________",
        "ln_maintenance_repair_period": "x_o_o___o___",
        "ln_armature_equip_renewal": "x_o_o___o___",
        "ln_not_using_durable_and_repairable_materials": "x_o_o___o___",
        "ln_repair_services": "x_o_o___o___"
      },
      "rw_map": [{
        "name": "d_ThermalComfort",
        "criterias": [{
          "name": "c_Temperature",
          "indicators": ["ln_very_cold", "ln_very_warm", "ln_unbalanced_temp", "ln_air_leakage", "ln_vertical_temp_diff", "ln_temp_diff_window_side"]
        }, {
          "name": "c_RadiantTemperature",
          "indicators": ["ln_direct_sun", "ln_direct_heat_source"]
        }, {
          "name": "c_RelativeHumanity",
          "indicators": ["ln_v_dry_air", "ln_v_humid_air"]
        }, {
          "name": "c_Temperature_Variation",
          "indicators": ["ln_fast_temp_var", "ln_low_temp_var"]
        }, {"name": "c_Airflow", "indicators": ["ln_af_aircondition_units", "ln_af_window_door_units"]}]
      }, {
        "name": "d_Indoor_Air_Quality",
        "criterias": [{
          "name": "c_indoor_fresh_air",
          "indicators": ["ln_quality_air_ventilation_sys", "ln_quality_air_outside"]
        }, {"name": "c_natural_ventilation", "indicators": ["ln_not_enough_natural_ventilation"]}, {
          "name": "c_odor",
          "indicators": ["ln_odor_outside", "ln_odor_air_pollution", "ln_odor_materials", "ln_odor_food", "ln_odor_toilets", "ln_odor_humidity"]
        }]
      }, {
        "name": "d_AcousticComfort",
        "criterias": [{
          "name": "c_NoiseLevel",
          "indicators": ["ln_noise_talking", "ln_noise_footstep", "ln_noise_outside", "ln_noise_venntilation_sys_equip", "ln_noise_lighting_equip", "ln_noise_office_equip", "ln_noise_furniture_door"]
        }, {
          "name": "c_Echo_Reflexion",
          "indicators": ["ln_echo_work_env", "ln_echo_meeting_room", "ln_echo_confer_room", "ln_echo_social_area"]
        }, {"name": "c_Acoustic_Privacy", "indicators": ["ln_no_acoustic_work_env", "ln_no_acoustic_meet_room"]}]
      }, {
        "name": "d_VisualComfort",
        "criterias": [{"name": "c_day_light", "indicators": ["ln_not_enough_sunlight"]}, {
          "name": "c_artificial_light",
          "indicators": ["ln_quality_work_env", "ln_amonut_mytable", "ln_shadows_lighting_env", "ln_constant_vibration_lighting_env"]
        }, {
          "name": "c_glare_flash",
          "indicators": ["ln_cause_lighting_env", "ln_cause_direct_sunglight"]
        }, {"name": "c_reflection", "indicators": ["ln_reflection_onscreens"]}, {
          "name": "c_visual_privacy",
          "indicators": ["ln_visual_privacy_work_env", "ln_visual_privacy_meeting_room", "ln_mycompscreen_seen"]
        }, {"name": "c_view_connection", "indicators": ["ln_notbeing_to_see_outside", "ln_view_from_mytable"]}]
      }, {
        "name": "d_BuildingDesign",
        "criterias": [{
          "name": "c_space_sufficient",
          "indicators": ["ln_s_insuff_work_space", "ln_s_insuff_work_table", "ln_s_insuff_social_areas", "ln_s_insuff_meeting_room_common_work_env", "ln_s_insuff_car_park_areas", "ln_s_insuff_storage_areas", "ln_s_insuff_restrooms", "ln_s_insuff_storey_height", "ln_s_insuff_elevators_escalators", "ln_s_insuff_outdoor_areas"]
        }, {
          "name": "c_layout_plan",
          "indicators": ["ln_lp_work_env", "ln_lp_insuff_directio_signs", "ln_lp_nointeraction_bet_employ", "ln_lp_distr_cause_human_circulation", "ln_lp_distr_cause_other_comp_scre", "ln_lp_distr_cause_nonsuitable_work_env_disabled_people"]
        }, {
          "name": "c_interior_design",
          "indicators": ["ln_indoor_esthetics", "ln_work_env_not_personalized", "ln_color_text_work_env", "ln_disfunctional_work_env", "ln_insuff_safety_precautions", "ln_indurable_furnitures_armatures", "ln_no_indoor_plans"]
        }, {
          "name": "c_furniture",
          "indicators": ["ln_comfort_level", "ln_ergonomic", "ln_not_customizable", "ln_not_modular"]
        }, {
          "name": "c_outdoor_design",
          "indicators": ["ln_diff_reach_outdoor_areas", "ln_design_outdoor_areas", "ln_landscaping"]
        }, {
          "name": "c_vibation",
          "indicators": ["ln_by_wind", "ln_by_vehicles", "ln_by_users", "ln_by_aircond_ventilation_sys"]
        }]
      }, {
        "name": "d_Facility_Services",
        "criterias": [{
          "name": "c_ability_control_confort_factor",
          "indicators": ["ln_heating_cooling_cannot_controlled", "ln_hvac", "ln_lighting_equipment_cannot_controlled", "ln_sunshade_equipment_cannot_controlled", "ln_natural_ventilation_cannot_controlled", "ln_water_temp_restroom_cannot_controlled"]
        }, {
          "name": "c_availability_control_devices",
          "indicators": ["ln_no_ins_book", "ln_ins_book_not_understand", "ln_equip_can_not_calibrate_sensitively"]
        }, {
          "name": "c_service_quality_facility_manage",
          "indicators": ["ln_ventilation_air_cond_services", "ln_waste_management", "ln_security", "ln_cleaning", "ln_health_safety_procedures", "ln_pest_control", "ln_mail_services", "ln_speed_fm_responces", "ln_expertise_fm_company_OM", "ln_user_feedback_not_addressed", "ln_annoucement_fm_services"]
        }, {
          "name": "c_maintenance",
          "indicators": ["ln_maintenance_repair_period", "ln_armature_equip_renewal", "ln_not_using_durable_and_repairable_materials", "ln_repair_services"]
        }]
      }]
    });


})();

(function () {
  'use strict';

  angular
    .module('rateWorkspaceServer')
    .config(config)
    .directive('header', function () {
      return {
        templateUrl: 'app/shared/main/header/header.tpl.html',
        controller: 'HeaderController',
        controllerAs: 'vm'
      };
    }).directive('userAvatar', function () {
    return {
      replace: true,
      template: '<svg class="user-avatar" viewBox="0 0 128 128" height="64" width="64" pointer-events="none" display="block" > <path fill="#FF8A80" d="M0 0h128v128H0z"/> <path fill="#FFE0B2" d="M36.3 94.8c6.4 7.3 16.2 12.1 27.3 12.4 10.7-.3 20.3-4.7 26.7-11.6l.2.1c-17-13.3-12.9-23.4-8.5-28.6 1.3-1.2 2.8-2.5 4.4-3.9l13.1-11c1.5-1.2 2.6-3 2.9-5.1.6-4.4-2.5-8.4-6.9-9.1-1.5-.2-3 0-4.3.6-.3-1.3-.4-2.7-1.6-3.5-1.4-.9-2.8-1.7-4.2-2.5-7.1-3.9-14.9-6.6-23-7.9-5.4-.9-11-1.2-16.1.7-3.3 1.2-6.1 3.2-8.7 5.6-1.3 1.2-2.5 2.4-3.7 3.7l-1.8 1.9c-.3.3-.5.6-.8.8-.1.1-.2 0-.4.2.1.2.1.5.1.6-1-.3-2.1-.4-3.2-.2-4.4.6-7.5 4.7-6.9 9.1.3 2.1 1.3 3.8 2.8 5.1l11 9.3c1.8 1.5 3.3 3.8 4.6 5.7 1.5 2.3 2.8 4.9 3.5 7.6 1.7 6.8-.8 13.4-5.4 18.4-.5.6-1.1 1-1.4 1.7-.2.6-.4 1.3-.6 2-.4 1.5-.5 3.1-.3 4.6.4 3.1 1.8 6.1 4.1 8.2 3.3 3 8 4 12.4 4.5 5.2.6 10.5.7 15.7.2 4.5-.4 9.1-1.2 13-3.4 5.6-3.1 9.6-8.9 10.5-15.2M76.4 46c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6-.1-.9.7-1.6 1.6-1.6zm-25.7 0c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6-.1-.9.7-1.6 1.6-1.6z"/> <path fill="#E0F7FA" d="M105.3 106.1c-.9-1.3-1.3-1.9-1.3-1.9l-.2-.3c-.6-.9-1.2-1.7-1.9-2.4-3.2-3.5-7.3-5.4-11.4-5.7 0 0 .1 0 .1.1l-.2-.1c-6.4 6.9-16 11.3-26.7 11.6-11.2-.3-21.1-5.1-27.5-12.6-.1.2-.2.4-.2.5-3.1.9-6 2.7-8.4 5.4l-.2.2s-.5.6-1.5 1.7c-.9 1.1-2.2 2.6-3.7 4.5-3.1 3.9-7.2 9.5-11.7 16.6-.9 1.4-1.7 2.8-2.6 4.3h109.6c-3.4-7.1-6.5-12.8-8.9-16.9-1.5-2.2-2.6-3.8-3.3-5z"/> <circle fill="#444" cx="76.3" cy="47.5" r="2"/> <circle fill="#444" cx="50.7" cy="47.6" r="2"/> <path fill="#444" d="M48.1 27.4c4.5 5.9 15.5 12.1 42.4 8.4-2.2-6.9-6.8-12.6-12.6-16.4C95.1 20.9 92 10 92 10c-1.4 5.5-11.1 4.4-11.1 4.4H62.1c-1.7-.1-3.4 0-5.2.3-12.8 1.8-22.6 11.1-25.7 22.9 10.6-1.9 15.3-7.6 16.9-10.2z"/> </svg>'
    };
  }).directive('myCustomDropdown', function () {
    return {
      // template: '<md-select style="margin:0px!important;" class="form-control"  ng-model="colFilter.term"><md-option ng-value="option" ng-repeat="option in colFilter.options">{{option.name}}</md-option></md-md-sel>'
      template: '<select style="word-wrap: normal" class="form-control" ng-model="colFilter.term" ng-options="option.id as option.name for option in colFilter.options"></select>'
    };
  });
  // .directive('rwFooter', function() {
  //   return {
  //     templateUrl: 'app/shared/main/footer/footer.tpl.html',
  //     controller: 'FooterController',
  //     controllerAs: 'vm',
  //   };
  // })
  ;

  /** @ngInject */
  function config($logProvider, $httpProvider, bim_address, toastrConfig, $mdThemingProvider, $locationProvider, $translateProvider, $sceDelegateProvider, tmhDynamicLocaleProvider) {
    // $httpProvider.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    // $httpProvider.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
    // $httpProvider.defaults.headers.common['Access-Control-Allow-Methods'] = "GET,PUT,POST,DELETE,PATCH,OPTIONS";
    // $httpProvider.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
    // Enable log
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });
    $translateProvider.useStaticFilesLoader({
      prefix: '/app/configs/translations/',
      suffix: '.json'
    });
    $translateProvider.preferredLanguage('tr');
    moment.locale('tr');

    // $sceDelegateProvider.resourceUrlWhitelist([
    //   bim_address+"/*"
    // ]);
    tmhDynamicLocaleProvider.localeLocationPattern('/lang/angular-locale_{{locale}}.js');
    tmhDynamicLocaleProvider.defaultLocale('tr');
    moment.defineLocale('tr', {
      months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
      monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
      weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
      weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
      weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
      },
      calendar: {
        sameDay: '[bugün saat] LT',
        nextDay: '[yarın saat] LT',
        nextWeek: '[gelecek] dddd [saat] LT',
        lastDay: '[dün] LT',
        lastWeek: '[geçen] dddd [saat] LT',
        sameElse: 'L'
      },
      relativeTime: {
        future: '%s sonra',
        past: '%s önce',
        s: 'birkaç saniye',
        ss: '%d saniye',
        m: 'bir dakika',
        mm: '%d dakika',
        h: 'bir saat',
        hh: '%d saat',
        d: 'bir gün',
        dd: '%d gün',
        M: 'bir ay',
        MM: '%d ay',
        y: 'bir yıl',
        yy: '%d yıl'
      },
      ordinal: function (number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'Do':
          case 'DD':
            return number;
          default:
            if (number === 0) {  // special case for zero
              return number + '\'ıncı';
            }
            var a = number % 10,
              b = number % 100 - a,
              c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        }
      },
      week: {
        dow: 1, // Monday is the first day of the week.
        doy: 7  // The week that contains Jan 1st is the first week of the year.
      }
    });
    moment.locale('tr');
    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    //$qProvider.errorOnUnhandledRejections(false);
    var triCyanMap = $mdThemingProvider.extendPalette('cyan', {
      'contrastDefaultColor': 'light',
      'contrastLightColors': '500 700 800 900',
      'contrastStrongLightColors': '500 700 800 900'
    });
    $mdThemingProvider.definePalette('amazingPaletteName', {
      '50': 'c2daef',
      '100': 'bdd7ee',
      '200': 'aeceea',
      '300': '9ac2e5',
      '400': '85b6e0',
      '500': '1F4E79',//Butonlar ve paneller için #1F4E79 koyu mavi
      '600': '5d9dd5',
      '700': '4991d0',
      '800': '3485cb',
      '900': 'c2daef',
      'A100': 'c2daef',
      'A200': '0070C0',
      'A400': '0070C0',
      'A700': '0070C0',
      'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                          // on this palette should be dark or light
      'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'],
      'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });
    // Register the new color palette map with the name triCyan
    $mdThemingProvider.definePalette('triCyan', triCyanMap);
    $mdThemingProvider.theme('default')
      .primaryPalette('amazingPaletteName')
      .accentPalette('pink')
      .warnPalette('deep-orange')
      .backgroundPalette('amazingPaletteName');
  }

})();

angular.module("rateWorkspaceServer").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/home.html","<div layout=vertical layout-fill><md-content><header><acme-navbar creation-date=vm.creationDate></acme-navbar></header><section class=jumbotron><h1>\'Allo, \'Allo!</h1><p class=lead><img src=assets/images/yeoman.png alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><md-button class=\"md-raised animated infinite\" ng-class=vm.classAnimation ng-click=vm.showToastr()>Splendid Toastr</md-button><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></section><div class=techs layout-align=center><md-card ng-repeat=\"awesomeThing in vm.awesomeThings | orderBy:\'rank\'\"><md-card-content><img class=pull-right ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><h3 class=md-title>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p></md-card-content><div class=md-action-buttons><md-button ng-href=\"{{ awesomeThing.url }}\">Website</md-button></div></md-card></div></md-content></div>");
$templateCache.put("app/main/main.tpl.html","<div layout-padding ng-cloak=\"\" layout=column flex><h1 style=\"text-decoration:underline;font-size:6vh;color:#0070C0;text-align: center\">Arı-3 Binası</h1><div hide show-gt-md layout=row><div layout=column flex=20 flex-offset=30><section layout-gt-md=column layout-lt-md=column layout-align=\"center stretch\"><md-button class=\"md-raised md-primary flex\" ng-click=\"vm.submitBtn(\'rw_enter\')\">Şikayet Gir</md-button><!--<md-button class=\"md-raised md-primary flex \" ng-click=\"vm.submitBtn(\'rw_list\')\">Şikayetlerim</md-button>\n        <md-button class=\"md-raised md-primary flex \" ng-click=\"vm.submitBtn(\'rw_settings\')\">Ayarlar</md-button>\n        <md-button class=\"md-raised md-primary flex \" ng-click=\"vm.submitBtn(\'rw_about\')\">Hakkında</md-button>--><md-button class=\"md-warn md-raised md-hue-2 flex\" ng-click=\"vm.submitBtn(\'rw_logout\')\">Çıkış Yap</md-button></section></div><div layout=column flex=50><img src=/assets/images/bina.png width=254></div></div><div hide-gt-md flex><md-menu layout=column flex><md-button class=\"md-raised md-primary\" ng-click=\"vm.openMenu($mdMenu, $event)\">Menu</md-button><md-menu-content width=6><md-menu-item><md-button class=\"md-raised md-primary flex\" ng-click=\"vm.submitBtn(\'rw_enter\')\">Şikayet Gir</md-button></md-menu-item><!-- <md-menu-item>\n           <md-button class=\"md-raised md-primary flex \" ng-click=\"vm.submitBtn(\'rw_list\')\" ng-disabled=\"true\">Şikayetlerim</md-button>\n         </md-menu-item>\n         <md-menu-item>\n           <md-button class=\"md-raised md-primary flex \" ng-click=\"vm.submitBtn(\'rw_settings\')\" ng-disabled=\"true\">Ayarlar</md-button>\n         </md-menu-item>\n         <md-menu-item>\n           <md-button class=\"md-raised md-primary flex \" ng-click=\"vm.submitBtn(\'rw_about\')\" ng-disabled=\"true\">Hakkında</md-button>\n        </md-menu-item>--><md-menu-item><md-button class=\"md-warn md-raised md-hue-2 flex\" ng-click=\"vm.submitBtn(\'rw_logout\')\">Çıkış Yap</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/login/login.tpl.html","<div layout-padding layout=column ng-cloak=\"\"><md-card style=\"background-color: rgb(194,218,239)\"><md-card-title><md-card-title-text><span class=\"md-headline rw-center-lbl\" md-colors=\"{color:\'default-primary-A100\'}\">{{\'app_name\' | translate}}</span></md-card-title-text></md-card-title><img class=\"md-card-image rw-center-img flex-xs-80 flex-sm-40 flex-md-40 flex-gt-md-20\" src=/assets/images/itu-logo.png alt=\"Washed Out\"><md-card-content><form name=loginForm novalidate><div layout=row><div layout=column flex flex-offset-gt-sm=30 flex-gt-sm=40 layout-align-gt-md=\"center stretch\"><md-input-container><label>Kullanıcı Adı</label><input type=text ng-model=vm.loginModel.username name=username required><div ng-messages=loginForm.username.$error><div ng-message=required>Kullanıcı adı giriniz.</div></div></md-input-container><md-input-container><label>Şifre</label><input type=password ng-model=vm.loginModel.password name=password required><div ng-messages=loginForm.password.$error><div ng-message=required>Şifre giriniz..</div></div></md-input-container></div><div layout=row hide show-gt-sm flex=25></div></div></form></md-card-content><md-card-actions layout=columnn layout-align=\"center center\"><md-button ng-click=vm.submitForm() class=\"md-raised md-primary flex flex-gt-sm-40\">Giriş Yap</md-button></md-card-actions></md-card></div>");
$templateCache.put("app/admin/directive/complaintGridList/complaint.gridlist.tpl.html","<md-card flex><md-card-title><md-card-title-text><span class=md-subhead style=\"text-align: center\">ŞİKAYETLER</span></md-card-title-text></md-card-title><md-card-content flex><div dx-chart=gridOptions></div></md-card-content></md-card>");
$templateCache.put("app/admin/directive/bimModel/bim.model.tpl.html","<div layout=row><rw-left-nav reset-camera=resetCamera() zoom-in-camera=zoomInCamera() zoom-out-camera=zoomOutCamera() location-show=locationShow location-show=locationShow></rw-left-nav><div flex><md-card style=\"background-color: rgb(194,218,239)\"><md-card-title><md-card-title-text><strong>MODEL</strong></md-card-title-text></md-card-title><md-card-content><div id=viewerContainer class=bimsurfer-metadata><canvas id=canvas height=300 width=400></canvas></div></md-card-content></md-card></div></div>");
$templateCache.put("app/admin/directive/complaintView/admin.complaint.view.tpl.html","<md-card flex><md-card-title><md-card-title-text><div layout=row><div style=\"padding-right: 5px\"><strong>Şikayet:</strong></div><div>{{selectedComplaint.index}}</div></div></md-card-title-text></md-card-title><md-card-content><div layout=column layout-padding layout-align=\"space-around start\"><div layout=row><div flex style=\"padding-right: 5px\"><strong>Şikayet:</strong></div><div><span>{{selectedComplaint.indicator | translate}}</span></div></div><div layout=row><div flex style=\"padding-right: 5px\"><strong>Konum:</strong></div><div><span>{{selectedComplaint.locationName}}</span></div></div><div layout=row><div flex style=\"padding-right: 5px\"><strong>Kaynak:</strong></div><div><span>{{selectedComplaint.sourceName}}</span></div></div><div layout=row><div flex style=\"padding-right: 5px\"><strong>Zaman:</strong></div><div><span>{{selectedComplaint.time}}</span></div></div><div layout=row><div flex style=\"padding-right: 5px\"><strong>Müdahale:</strong></div><div><span>{{selectedComplaint.response_time}}</span></div></div><div layout=row><div flex style=\"padding-right: 5px\"><strong>Ek Bilgi:</strong></div><div><textarea readonly cols=80>{{selectedComplaint.message}}</textarea></div></div><div layout=row><div flex style=\"padding-right: 5px\"><strong>FM Ek Bilgi:</strong></div><div><textarea readonly cols=80>{{selectedComplaint.fm_message}}</textarea></div></div><div layout=row><div flex style=\"padding-right: 5px\"><strong>FM Teknisyen:</strong></div><div><span>{{selectedComplaint.fm_technician}}</span></div></div><div layout=row><div flex style=\"padding-right: 5px\"><strong>Durumu:</strong></div><div><span ng-show=\"selectedComplaint!=None\">{{\'chart_status_\'+selectedComplaint.status |translate}}</span></div></div><div><md-button ng-disabled=disableEdit() class=\"md-raised md-primary flex\" ng-click=show_edit()>DÜZENLE</md-button></div></div></md-card-content></md-card><div style=\"visibility: hidden\"><div class=md-dialog-container id=editDialog flex style=\"width: 90%\"><md-dialog layout-padding aria-label=\"Şikayet Düzenle :\"><md-dialog-content><md-card><md-card-title><md-card-title-text><div layout=row><div style=\"padding-right: 5px\"><strong>Şikayet Düzenle :</strong></div><div>{{editedComplaint.index}}</div></div></md-card-title-text></md-card-title><md-card-content><div layout=column><div layout=row><md-input-container><label>Şikayet:</label><md-select placeholder=Şikayet ng-model=indicator style=\"min-width: 200px\"><md-option ng-value=indicator ng-repeat=\"indicator in select_indicators\" ng-selected=\"indicator.id==selectedIndicator\">{{indicator.name}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container><label>Konum:</label><input ng-model=editedComplaint.locationName readonly></md-input-container><md-input-container><label>Kaynak:</label><input ng-model=editedComplaint.sourceName readonly></md-input-container></div><div layout=row><md-input-container><label>Zaman:</label><input ng-model=editedComplaint.time readonly></md-input-container><md-input-container><label>Müdahale:</label><input mdc-datetime-picker=\"\" date=true time=true type=text id=datetime placeholder=Date minutes=true min-date=date show-icon=true click-outside-to-close=true ng-model=momentDate class=\"dtp-no-msclear dtp-input md-input\"></md-input-container></div><div layout=row><md-input-container><label>Ek Bilgi:</label><textarea style=\"top:8px;left:2px;right: auto;resize: both\" ng-model=editedComplaint.message md-maxlength=150 rows=5 md-select-on-focus readonly></textarea></md-input-container><md-input-container><label>FM Ek Bilgi:</label><textarea style=\"top:8px;left:2px;right: auto;resize: both\" ng-model=editedComplaint.fm_message md-maxlength=150 rows=5 md-select-on-focus></textarea></md-input-container></div><div layout=row><md-input-container><label>Durumu:</label><md-select placeholder=Şikayet ng-model=status style=\"min-width: 200px\"><md-option ng-value=status ng-repeat=\"status in statuses\" ng-selected=\"status.id==selectedStatus\">{{status.name}}</md-option></md-select></md-input-container><md-input-container><label>Teknisyene Ata:</label><md-select placeholder=Teknisyen ng-model=technician style=\"min-width: 200px\"><md-option ng-value=tech ng-repeat=\"tech in technicians\" ng-selected=\"tech.id==selectedTechnician\">{{tech.name}}</md-option></md-select></md-input-container><!--<div><span ng-show=\"selectedComplaint!=None\">{{\'chart_status_\'+selectedComplaint.status |translate}}</span>--></div><div layout=row><md-button class=\"md-raised md-warn flex\" ng-click=hide_edit()>İPTAL</md-button><md-button class=\"md-raised md-primary flex\" ng-click=submit_edit()>KAYDET</md-button></div></div></md-card-content></md-card></md-dialog-content></md-dialog></div></div>");
$templateCache.put("app/admin/directive/footer/footer.tpl.html","<div layout-padding ng-cloak=\"\" layout=column flex></div>");
$templateCache.put("app/admin/directive/header/header.tpl.html","<div layout-padding ng-cloak=\"\" layout=column flex><!--<md-toolbar class=\"md-hue-2\">--><!--<div class=\"md-toolbar-tools\">--><!--&lt;!&ndash;<md-button class=\"md-icon-button\" aria-label=\"Settings\" ng-disabled=\"true\">&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<i class=\"material-icons\">menu</i>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;</md-button>&ndash;&gt;--><!--&lt;!&ndash;<h2 flex md-truncate>Toolbar with Disabled/Enabled Icon Buttons</h2>&ndash;&gt;--><!--&lt;!&ndash;<md-button class=\"md-icon-button\" aria-label=\"Favorite\">&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<i class=\"material-icons\">favorite</i>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;</md-button>&ndash;&gt;--><!--&lt;!&ndash;<md-button class=\"md-icon-button\" aria-label=\"More\">&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<i class=\"material-icons\">more_vert</i>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;</md-button>&ndash;&gt;--><!--</div>--><!--</md-toolbar>--></div>");
$templateCache.put("app/admin/directive/loading/admin.loading.tpl.html","<div style=\"width: 100%;\n   height: 100%;\n   top: 0;\n   left: 0;\n   position: fixed;\n   display: block;\n   opacity: 0.7;\n   background-color: #fff;\n   z-index: 99;\n   text-align: center\" ng-hide=isloaded()><md-progress-circular md-diameter=96></md-progress-circular></div>");
$templateCache.put("app/admin/modules/main/main.tpl.html","<style>md-content.md-default-theme {\n    background-color: #ededed;\n  }\n\n  md-divider {\n    color: #ededed;\n  }\n\n  md-card {\n    background-color: #fff;\n  }\n\n  md-card h2:first-of-type {\n    margin-top: 0;\n  }\n\n  md-toolbar .md-button.md-default-theme {\n    border-radius: 99%;\n  }\n\n  h2 {\n    font-weight: 400;\n  }\n\n  .md-toolbar-tools-bottom {\n    font-size: small;\n  }\n\n  .md-toolbar-tools-bottom :last-child {\n    opacity: 0.8;\n  }\n\n  md-toolbar:not(.md-hue-1),\n  .md-fab {\n    fill: #fff;\n  }\n\n  md-sidenav {\n    fill: #737373;\n  }\n\n  md-sidenav ng-md-icon {\n    position: relative;\n    top: 5px;\n  }\n\n  .user-avatar {\n    border-radius: 99%;\n  }</style><div layout=row flex><admin-loading></admin-loading><admin-header rw-selected=0></admin-header><div layout=column><admin-left-nav rw-selected=0></admin-left-nav></div><div><md-divider class=vertical-divider></md-divider></div><div flex=\"\"><div layout=row flex><!--  <complaint-grid-list data=\"grid_datas\" columns=\"grid_columns\" selected-grid-id=\"selected_grid_id\"\n                           flex></complaint-grid-list>--><md-card flex><md-card-title><md-card-title-text><span class=md-subhead style=\"text-align: center\">ŞİKAYETLER</span></md-card-title-text></md-card-title><md-card-content flex><div id=gridContainer dx-data-grid=gridOptions></div></md-card-content></md-card></div><div layout=row><div flex=50><md-card flex><md-card-content flex><div id=chart dx-chart=chartOptions flex-gt-md=45 flex=80 style=\"height: 300px\"></div></md-card-content></md-card></div><div flex=50><bim-model options=bimModelOptions complaint=selectedComplaint></bim-model></div></div></div></div><admin-footer admin-page-selected=0></admin-footer>");
$templateCache.put("app/admin/modules/login/admin.login.tpl.html","<div layout-padding layout=column ng-cloak=\"\"><md-card style=\"background-color: rgb(194,218,239)\"><md-card-title><md-card-title-text><span class=\"md-headline rw-center-lbl\" md-colors=\"{color:\'default-primary-A100\'}\">{{\'app_name\' | translate}}</span></md-card-title-text></md-card-title><img class=\"md-card-image rw-center-img flex-xs-80 flex-sm-40 flex-md-40 flex-gt-md-20\" src=/assets/images/itu-logo.png alt=\"Washed Out\"><md-card-content><form name=loginForm novalidate><div layout=row><div layout=column flex flex-offset-gt-sm=30 flex-gt-sm=40 layout-align-gt-md=\"center stretch\"><md-input-container><label>Kullanıcı Adı</label><input type=text ng-model=vm.loginModel.username name=username required><div ng-messages=loginForm.username.$error><div ng-message=required>Kullanıcı adı giriniz.</div></div></md-input-container><md-input-container><label>Şifre</label><input type=password ng-model=vm.loginModel.password name=password required><div ng-messages=loginForm.password.$error><div ng-message=required>Şifre giriniz..</div></div></md-input-container></div><div layout=row hide show-gt-sm flex=25></div></div></form></md-card-content><md-card-actions layout=columnn layout-align=\"center center\"><md-button ng-click=vm.submitForm() class=\"md-raised md-primary flex flex-gt-sm-40\">Giriş Yap</md-button></md-card-actions></md-card></div>");
$templateCache.put("app/main/directive/footer/footer.tpl.html","<div layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary flex\" ng-disabled=vm.disPrevBtn() ng-click=\"progress_btn(\'prev\')\">{{\'ln_f_prev\' | translate}}</md-button><md-button class=\"md-raised md-primary flex\" ng-hide=hideSubmitBtn() ng-click=vm.submit_btn()>{{\'ln_f_send_complaint\' | translate}}</md-button><md-button class=\"md-raised md-primary flex\" ng-hide=!hideSubmitBtn() ng-disabled=vm.disNextBtn() ng-click=\"progress_btn(\'next\')\">{{\'ln_f_next\' | translate}}</md-button></div>");
$templateCache.put("app/main/directive/header/header.tpl.html","<div layout-padding ng-cloak=\"\" layout=column flex><div hide show-gt-md><section layout-gt-md=row layout-lt-md=column layout-align=\"center stretch\"><md-button class=\"md-raised md-primary flex\" ng-click=\"submitBtn(\'t_main\')\"><div style=\"display: inline-flex;vertical-align: middle;align-items: center\"><i class=material-icons style=\"line-height: 90%;; margin-right: 5px\">home</i> <span>{{\'t_main\' | translate}}</span></div></md-button><md-button class=\"md-raised md-primary flex\" ng-disabled=sDisabled(0) ng-click=\"submitBtn(\'t_complaint\')\">{{\'t_complaint\' | translate}}</md-button><md-button class=\"md-raised md-primary flex\" ng-disabled=sDisabled(1) ng-click=\"submitBtn(\'t_location\')\">{{\'t_location\' | translate}}</md-button><md-button class=\"md-raised md-primary flex\" ng-disabled=sDisabled(2) ng-click=\"submitBtn(\'t_source\')\">{{\'t_source\' | translate}}</md-button><md-button class=\"md-raised md-primary flex\" ng-disabled=sDisabled(3) ng-click=\"submitBtn(\'t_time\')\">{{\'t_time\' | translate}}</md-button><md-button class=\"md-raised md-primary flex\" ng-disabled=sDisabled(4) ng-click=\"submitBtn(\'t_extra_info\')\">{{\'t_extra_info\' | translate}}</md-button><md-button class=\"md-warn md-raised md-hue-2 flex\" ng-click=\"submitBtn(\'rw_logout\')\">{{\'t_logout\' | translate}}</md-button></section><md-divider style=\"border: 1px solid rgb(31,78,121)\"></md-divider></div></div><div hide-gt-md flex><md-menu layout=column flex><md-button class=\"md-raised md-primary\" ng-click=\"openMenu($mdMenu, $event)\">Menu</md-button><md-menu-content width=6 ng-mouseleave=closeMenu($mdMenu,$event)><md-menu-item><md-button class=\"md-raised md-primary flex\" ng-click=\"submitBtn(\'t_main\')\"><div style=\"display: inline-flex;vertical-align: middle;align-items: center\"><i class=material-icons style=\"line-height: 90%;; margin-right: 5px\">home</i> <span>{{\'t_main\' | translate}}</span></div></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised md-primary flex\" ng-disabled=sDisabled(0) ng-click=\"submitBtn(\'t_complaint\')\">{{\'t_complaint\' | translate}}</md-button></md-menu-item><md-menu-item><md-button class=\"md-raised md-primary flex\" ng-disabled=sDisabled(1) ng-click=\"submitBtn(\'t_location\')\">{{\'t_location\' | translate}}</md-button></md-menu-item><md-menu-item><md-button class=\"md-raised md-primary flex\" ng-disabled=sDisabled(2) ng-click=\"submitBtn(\'t_source\')\">{{\'t_source\' | translate}}</md-button></md-menu-item><md-menu-item><md-button class=\"md-raised md-primary flex\" ng-disabled=vm.sDisabled(3) ng-click=\"submitBtn(\'t_time\')\">{{\'t_time\' | translate}}</md-button></md-menu-item><md-menu-item><md-button class=\"md-raised md-primary flex\" ng-disabled=vm.sDisabled(4) ng-click=\"submitBtn(\'t_extra_info\')\">{{\'t_extra_info\' | translate}}</md-button></md-menu-item><md-menu-item><md-button class=\"md-warn md-raised md-hue-2 flex\" ng-click=\"submitBtn(\'rw_logout\')\">{{\'t_logout\' | translate}}</md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/shared/main/header/header.tpl.html","<div hide show-gt-md layout-padding layout=row ng-cloak=\"\" ng-show=vm.isShow()><div flex><center><img class=\"md-card-image rw-center-img flex-xs-80 flex-sm-40 flex-md-40 flex-gt-md-20\" src=/assets/images/itu-logo.png alt=\"Washed Out\"></center></div><!--<div flex>--><!--<span class=\"md-headline rw-center-lbl \" md-colors=\"{color:\'default-primary-A100\'}\">{{\'app_name\' | translate}}</span>--><!--</div>--></div>");
$templateCache.put("app/main/modules/complaintLocation/complaintLocation.tpl.html","<div><rw-header rw-selected=1></rw-header><div><md-nav-bar md-no-ink-bar=disableInkBar md-selected-nav-item=currentNavItem nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"selectTab(\'map\')\" name=map selected>{{\'ln_l_auto\' | translate}}</md-nav-item><md-nav-item md-nav-click=\"selectTab(\'list\')\" name=list>{{\'ln_l_space\' | translate}}</md-nav-item></md-nav-bar><div layout=column ng-hide=hideElementSpaces()><div layout=row><md-input-container><label>{{\'t_select_space\' | translate}}</label><md-select placeholder=\"{{\'t_select_space\' | translate}}\" ng-model=space md-on-open=openSpace() md-on-close=closeSpace() style=\"min-width: 200px\" ng-change=updateSpace(space)><md-option ng-value=space ng-repeat=\"space in spaces\">{{space.name}}</md-option></md-select></md-input-container></div></div><div layout=row><rw-left-nav reset-camera=resetCamera() zoom-in-camera=zoomInCamera() zoom-out-camera=zoomOutCamera() location-on=locationOn() location-show=locationShow></rw-left-nav><div flex><md-card style=\"background-color: rgb(194,218,239)\"><md-card-content><div style=\"color: rgb(255,64,129)\" id=loc_lbl></div><div id=viewerContainer flex=100><canvas id=canvas></canvas></div></md-card-content></md-card></div></div></div><rw-footer rw-selected=1></rw-footer></div>");
$templateCache.put("app/main/modules/complaintInsert/complaintInsert.tpl.html","<div><rw-header rw-selected=0></rw-header><md-tabs md-dynamic-height md-border-bottom md-selected=selectedTabIndex><md-tab label=\"Arama Yap\" md-on-select=\"vm.selectTab(\'search\')\"><md-card style=\"background-color: rgb(194,218,239)\"><md-card-content><md-autocomplete style=\"background-color: white\" ng-disabled=vm.isDisabled md-no-cache=vm.noCache , md-selected-item=search_selectedItem , md-search-text=searchText , md-search-text-change=vm.searchTextChange(searchText) md-selected-item-change=selectedItemChange(item) md-items=\"item in querySearch(searchText)\" md-item-text=item.value md-min-length=0 placeholder=\"{{\'complaint_placeholder\' | translate}}\"><md-item-template><span md-highlight-text=vm.searchText md-highlight-flags=^i>{{item.value}}</span></md-item-template><!--<md-not-found>--><!--No states matching \"{{vm.searchText}}\" were found.--><!--<a ng-click=\"vm.newState(vm.searchText)\">Create a new one!</a>--><!--</md-not-found>--></md-autocomplete></md-card-content><md-divider></md-divider></md-card></md-tab><md-tab label=\"Listeden Seç\" md-on-select=\"vm.selectTab(\'list\')\"><!--Tuna--><md-card style=\"background-color: rgb(194,218,239)\"><md-card-content><md-input-container><label>{{\'t_select_dimension\' | translate}}</label><md-select placeholder=\"{{\'t_select_dimension\' | translate}}\" ng-model=dimension md-on-open=loadDimensions() style=\"min-width: 200px\" ng-change=updateDimension(dimension)><md-option ng-value=dimension ng-repeat=\"dimension in dimensions\" ng-selected=\"dimension.id==selected_dimension\">{{dimension.name}}</md-option></md-select></md-input-container><md-input-container><label>{{\'t_select_criteria\' | translate}}</label><md-select ng-show=dimension placeholder=\"{{\'t_select_criteria\' | translate}}\" ng-model=criteria style=\"min-width: 200px\" ng-change=updateCriteria(criteria)><md-option ng-value=criteria ng-repeat=\"criteria in criterias\" ng-selected=\"criteria.id==selected_criteria\">{{criteria.name}}</md-option></md-select></md-input-container><md-input-container><label>{{\'t_select_indicator\' | translate}}</label><md-select ng-show=criteria placeholder=\"{{\'t_select_indicator\' | translate}}\" ng-model=indicator style=\"min-width: 200px\" ng-change=updateIndicator(indicator)><md-option ng-value=indicator ng-repeat=\"indicator in indicators\" ng-selected=\"indicator.id==selected_indicator\">{{indicator.name}}</md-option></md-select></md-input-container></md-card-content></md-card></md-tab><!-- <md-tab label=\"Yaz\" md-on-select=\"vm.selectTab(\'write\')\" ng-disabled=\"true\"><\n      <md-card style=\"background-color: rgb(194,218,239)\">\n        <md-card-content>\n          <md-input-container class=\"md-block\">\n            <label>{{\'t_your_complaint\' | translate}}</label>\n            <textarea ng-model=\"vm.complaint.textMessage\" md-maxlength=\"150\" rows=\"5\" md-select-on-focus></textarea>\n          </md-input-container>\n        </md-card-content>\n      </md-card>\n    </md-tab>--></md-tabs><rw-footer rw-selected=0></rw-footer></div>");
$templateCache.put("app/main/modules/complaintPreview/complaintPreview.tpl.html","<div><rw-header rw-selected=5></rw-header><md-content md-theme=docs-dark layout-gt-sm=row layout-padding layout-align=\"center center\"><div layout-gt-md=column flex-gt-md=100 flex-lt-md=80><div layout=row layout-align=\"center center\"><h1 class=md-display-2 style=\"color: rgb(31,78,121)\"><ins>Önizleme</ins></h1></div><div layout=row layout-wrap style=margin-bottom:5px><div flex><a href=/enter style=color:rgb(31,78,121)>Şikayet:</a></div><div><span>{{indicator}}</span></div></div><div layout=row layout-wrap style=margin-bottom:5px><div flex><a href=/location style=color:rgb(31,78,121)>Konum:</a></div><div><span>{{locationName}}</span></div></div><div layout=row layout-wrap style=margin-bottom:5px><div flex><a href=/source style=color:rgb(31,78,121)>Kaynak:</a></div><div><span>{{sourceName}}</span></div></div><div layout=row layout-wrap style=margin-bottom:5px><div flex><a href=/time style=color:rgb(31,78,121)>Zaman:</a></div><div><span>{{time}}</span></div></div><div layout=row layout-wrap style=margin-bottom:5px><div flex><a href=/time style=color:rgb(31,78,121)>Müdahale:</a></div><div><span>{{response_time}}</span></div></div><div layout=row layout-wrap><div flex><a href=/time style=color:rgb(31,78,121)>Ek Bilgi:</a></div><div><span>{{message}}</span></div></div></div></md-content><rw-footer rw-selected=5></rw-footer></div>");
$templateCache.put("app/main/modules/complaintMessage/complaintMessage.tpl.html","<div><rw-header rw-selected=4></rw-header><md-content layout-gt-sm=row layout-padding layout-align=\"center center\"><div layout=column flex><md-input-container class=\"md-icon-float md-block\"><label>{{\'ln_t_complaint_text_area\' | translate}}</label><textarea style=\"top:8px;left:2px;right: auto\" ng-model=textMessage ng-change=textChange() md-maxlength=150 rows=5 md-select-on-focus></textarea></md-input-container></div></md-content><rw-footer rw-selected=4></rw-footer></div>");
$templateCache.put("app/main/modules/complaintTime/complaintTime.tpl.html","<div><rw-header rw-selected=3></rw-header><md-content layout-gt-sm=row layout-padding layout-align=\"center center\"><div layout=column flex><md-card><md-card-title><md-card-title-text><span class=md-subhead>Güncel Tarih ve Zamanı Kullan</span></md-card-title-text></md-card-title><md-card-content><md-input-container class=\"md-icon-float md-block\"><label>Tarih ve Saat</label><input mdc-datetime-picker=\"\" date=true time=true type=text id=datetime ng-change=timeChange() placeholder=Date minutes=true min-date=date show-icon=true click-outside-to-close=true ng-model=momentDate class=\"dtp-no-msclear dtp-input md-input\"></md-input-container></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-subhead>Müdahale için Tarih ve Zamanı Kullan</span></md-card-title-text></md-card-title><md-card-content><md-input-container class=\"md-icon-float md-block\"><label>Tarih ve Saat</label><input mdc-datetime-picker=\"\" date=true time=true type=text id=datetime2 ng-change=timeChange2() placeholder=Date minutes=true min-date=date show-icon=true click-outside-to-close=true ng-model=momentDate2 class=\"dtp-no-msclear dtp-input md-input\"></md-input-container></md-card-content></md-card></div></md-content><rw-footer rw-selected=3></rw-footer></div>");
$templateCache.put("app/main/modules/complaintSource/complaintSource.tpl.html","<div flex layout=column><rw-header rw-selected=2 flex></rw-header><div><md-nav-bar md-no-ink-bar=disableInkBar md-selected-nav-item=currentNavItem nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"selectTab(\'element\')\" name=element selected>{{\'ln_s_element\' | translate}}</md-nav-item><md-nav-item md-nav-click=\"selectTab(\'location\')\" name=location>{{\'ln_s_location\' | translate}}</md-nav-item></md-nav-bar><div layout=column ng-hide=hideElementSpaces()><div layout=row><md-input-container><label>{{\'t_select_space\' | translate}}</label><md-select placeholder=\"{{\'t_select_space\' | translate}}\" ng-model=space md-on-open=openSpace() md-on-close=closeSpace() style=\"min-width: 200px\" ng-change=updateSpace(space)><md-option ng-value=space ng-repeat=\"space in spaces\">{{space.name}}</md-option></md-select></md-input-container></div></div><div layout=column ng-hide=hideElementBtns()><div layout=row><md-button class=\"md-raised md-primary flex\" ng-disabled=eDisabled(0) ng-click=onChange(0)>{{\'ln_s_zemin\' | translate}}</md-button><md-button class=\"md-raised md-primary flex\" ng-disabled=eDisabled(1) ng-click=onChange(1)>{{\'ln_s_tavan\' | translate}}</md-button></div></div><div layout=row><rw-left-nav reset-camera=resetCamera() zoom-in-camera=zoomInCamera() zoom-out-camera=zoomOutCamera() location-on=locationOn() location-show=locationShow></rw-left-nav><div flex><md-card style=\"background-color: rgb(194,218,239)\"><md-card-content><div style=\"color: rgb(255,64,129)\" id=loc_lbl></div><div id=viewerContainer class=bimsurfer-metadata><canvas id=canvas></canvas></div></md-card-content></md-card></div></div></div><rw-footer rw-selected=2></rw-footer></div>");
$templateCache.put("app/admin/modules/complaint/filter_list/admin.complaint.tpl.html","<style>md-content.md-default-theme {\n    background-color: #ededed;\n  }\n\n  md-divider {\n    color: #ededed;\n  }\n\n  md-card {\n    background-color: #fff;\n  }\n\n  md-card h2:first-of-type {\n    margin-top: 0;\n  }\n\n  md-toolbar .md-button.md-default-theme {\n    border-radius: 99%;\n  }\n\n  h2 {\n    font-weight: 400;\n  }\n\n  .md-toolbar-tools-bottom {\n    font-size: small;\n  }\n\n  .md-toolbar-tools-bottom :last-child {\n    opacity: 0.8;\n  }\n\n  md-toolbar:not(.md-hue-1),\n  .md-fab {\n    fill: #fff;\n  }\n\n  md-sidenav {\n    fill: #737373;\n  }\n\n  md-sidenav ng-md-icon {\n    position: relative;\n    top: 5px;\n  }\n\n  .user-avatar {\n    border-radius: 99%;\n  }</style><div layout=row flex><admin-loading></admin-loading><admin-header rw-selected=3></admin-header><div layout=column><admin-left-nav rw-selected=3></admin-left-nav></div><div><md-divider class=vertical-divider></md-divider></div><div flex=\"\"><md-tabs md-dynamic-height md-border-bottom md-center-tabs flex=\"\"><md-tab md-on-select=tabClick(1) label=Liste><md-content class=md-padding><div flex=\"\"><div layout=row flex><md-card flex><md-card-title><md-card-title-text><span class=md-subhead style=\"text-align: center\">ŞİKAYETLER</span></md-card-title-text></md-card-title><md-card-content flex><div id=gridContainer dx-data-grid=gridOptions></div></md-card-content></md-card></div></div></md-content></md-tab><md-tab md-on-select=tabClick(2) label=Model><md-content class=md-padding><div layout=column><div layout=row><md-button class=\"md-raised md-primary flex\" ng-disabled=eDisabled(1) ng-click=onChange(1)>Konuma Göre</md-button><md-button class=\"md-raised md-primary flex\" ng-disabled=eDisabled(0) ng-click=onChange(0)>Kaynağa Göre</md-button></div></div><div layout=row><div layout=row flex=30><div id=gridContainer_filtered dx-data-grid=gridOptions_filtered></div></div><div flex><bim-model options=bimModelOptions complaint=selectedComplaint isfull=true bim-loaded=bimLoaded()></bim-model></div></div></md-content></md-tab></md-tabs></div></div><admin-footer admin-page-selected=0></admin-footer>");
$templateCache.put("app/admin/directive/navs/leftnav/left_nav.tpl.html","<style>.sidenav {\n    height: 100%;\n    width: 0;\n    position: fixed;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    overflow-x: hidden;\n    transition: 0.5s;\n    padding-top: 60px;\n  }\n\n  .sidenav a {\n    padding: 8px 8px 8px 32px;\n    text-decoration: none;\n    font-size: 25px;\n    display: block;\n    transition: 0.3s;\n  }\n\n  .sidenav a:hover {\n    color: #f1f1f1;\n  }\n\n  .sidenav .closebtn {\n    position: absolute;\n    top: 0;\n    right: 25px;\n    font-size: 36px;\n    margin-left: 50px;\n  }\n\n  #main {\n    transition: margin-left .5s;\n    padding: 16px;\n  }\n\n  @media screen and (max-height: 450px) {\n    .sidenav {\n      padding-top: 15px;\n    }\n\n    .sidenav a {\n      font-size: 18px;\n    }\n  }</style><div id=main><div id=mySidenav class=sidenav><a href=javascript:void(0) class=closebtn ng-click=closeNav()>&times;</a><div ng-show=isOpen><user-avatar></user-avatar><span></span><div>{{username}}</div></div><md-list class=md-dense><md-list-item><md-button ng-disabled=sDisabled(0) ng-class=\"{\'md-raised md-primary\':sDisabled(0)}\" ng-click=sLink(0) flex style=\"text-align: start\"><md-icon>view_module</md-icon>Ana Sayfa</md-button></md-list-item><md-divider></md-divider><md-subheader>Şikayet</md-subheader><md-list-item><md-button ng-disabled=sDisabled(1) ng-class=\"{\'md-raised md-primary\':sDisabled(1)}\" ng-click=sLink(1) flex style=\"text-align: start\"><md-icon>assignment</md-icon>Şikayetler</md-button></md-list-item><md-list-item><md-button ng-disabled=sDisabled(2) ng-class=\"{\'md-raised md-primary\':sDisabled(2)}\" ng-click=sLink(2) flex style=\"text-align: start\"><md-icon>query_builder</md-icon>Bekleyenler</md-button></md-list-item><md-list-item><md-button ng-disabled=sDisabled(3) ng-class=\"{\'md-raised md-primary\':sDisabled(3)}\" ng-click=sLink(3) flex style=\"text-align: start\"><md-icon>filter_list</md-icon>Filtrele</md-button></md-list-item><md-divider></md-divider><md-subheader>Model & İstatistikler</md-subheader><md-list-item><md-button ng-disabled=sDisabled(4) ng-class=\"{\'md-raised md-primary\':sDisabled(4)}\" ng-click=sLink(4) flex style=\"text-align: start\"><md-icon>insert_chart</md-icon>İstatistikler</md-button></md-list-item><!-- <md-list-item>\n        <md-button ng-disabled=\"sDisabled(5)\" ng-class=\"{\'md-raised md-primary\':sDisabled(5)}\" ng-click=\"sLink(5)\" flex\n                   style=\"text-align: start\">\n          <md-icon>cloud_download</md-icon>\n          Model\n        </md-button>\n      </md-list-item>--><md-divider></md-divider><md-subheader></md-subheader><md-list-item><md-button class=\"md-raised md-warn\" ng-click=sLink(-1) flex style=\"text-align: start\"><md-icon>exit_to_app</md-icon>ÇIKIŞ</md-button></md-list-item></md-list></div><span ng-hide=isOpen style=font-size:30px;cursor:pointer ng-click=openNav()>&#9776;</span></div><!--\n<md-sidenav layout=\"column\" class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\">\n  <md-toolbar class=\"md-tall md-hue-2\">\n    <span flex></span>\n    <md-button ng-click=\'close()\'>\n      <md-icon>arrow_back</md-icon>\n    </md-button>\n    <div layout=\"column\" class=\"md-toolbar-tools-bottom inset\">\n      <user-avatar></user-avatar>\n      <span></span>\n      <div>{{username}}</div>\n    </div>\n  </md-toolbar>\n  <md-content>\n    <md-list class=\"md-dense\">\n      <md-list-item>\n        <md-button ng-disabled=\"sDisabled(0)\" ng-class=\"{\'md-raised md-primary\':sDisabled(0)}\" ng-click=\"sLink(0)\" flex style=\"text-align: start\">\n          <md-icon>view_module</md-icon>\n          Ana Sayfa\n        </md-button>\n      </md-list-item>\n      <md-divider></md-divider>\n      <md-subheader>Şikayet</md-subheader>\n      <md-list-item>\n        <md-button ng-disabled=\"sDisabled(1)\" ng-class=\"{\'md-raised md-primary\':sDisabled(1)}\" ng-click=\"sLink(1)\" flex style=\"text-align: start\">\n          <md-icon>assignment</md-icon>\n          Şikayetler\n        </md-button>\n      </md-list-item>\n      <md-list-item>\n          <md-button ng-disabled=\"sDisabled(2)\" ng-class=\"{\'md-raised md-primary\':sDisabled(2)}\" ng-click=\"sLink(2)\" flex style=\"text-align: start\">\n            <md-icon>query_builder</md-icon>\n              Bekleyenler\n          </md-button>\n      </md-list-item>\n      <md-list-item>\n          <md-button ng-disabled=\"sDisabled(3)\" ng-class=\"{\'md-raised md-primary\':sDisabled(3)}\" ng-click=\"sLink(3)\" flex style=\"text-align: start\">\n            <md-icon>filter_list</md-icon>\n            Filtrele\n          </md-button>\n      </md-list-item>\n      <md-divider></md-divider>\n      <md-subheader>Model & İstatistikler</md-subheader>\n      <md-list-item>\n        <md-button ng-disabled=\"sDisabled(4)\" ng-class=\"{\'md-raised md-primary\':sDisabled(4)}\" ng-click=\"sLink(4)\" flex style=\"text-align: start\">\n          <md-icon>insert_chart</md-icon>\n          İstatistikler\n        </md-button>\n      </md-list-item>\n      <md-list-item>\n        <md-button ng-disabled=\"sDisabled(5)\" ng-class=\"{\'md-raised md-primary\':sDisabled(5)}\" ng-click=\"sLink(5)\" flex style=\"text-align: start\">\n          <md-icon>cloud_download</md-icon>\n          Model\n        </md-button>\n      </md-list-item>\n      <md-divider></md-divider>\n      <md-subheader></md-subheader>\n      <md-list-item>\n        <md-button class=\"md-raised md-warn\" ng-click=\"sLink(-1)\" flex style=\"text-align: start\">\n          <md-icon>exit_to_app</md-icon>\n          ÇIKIŞ\n        </md-button>\n      </md-list-item>\n    </md-list>\n  </md-content>\n</md-sidenav>-->");
$templateCache.put("app/admin/modules/complaint/list/admin.complaint.tpl.html","<style>md-content.md-default-theme {\n    background-color: #ededed;\n  }\n\n  md-divider {\n    color: #ededed;\n  }\n\n  md-card {\n    background-color: #fff;\n  }\n\n  md-card h2:first-of-type {\n    margin-top: 0;\n  }\n\n  md-toolbar .md-button.md-default-theme {\n    border-radius: 99%;\n  }\n\n  h2 {\n    font-weight: 400;\n  }\n\n  .md-toolbar-tools-bottom {\n    font-size: small;\n  }\n\n  .md-toolbar-tools-bottom :last-child {\n    opacity: 0.8;\n  }\n\n  md-toolbar:not(.md-hue-1),\n  .md-fab {\n    fill: #fff;\n  }\n\n  md-sidenav {\n    fill: #737373;\n  }\n\n  md-sidenav ng-md-icon {\n    position: relative;\n    top: 5px;\n  }\n\n  .user-avatar {\n    border-radius: 99%;\n  }</style><div layout=row flex><admin-loading></admin-loading><admin-header rw-selected=1></admin-header><div layout=column><admin-left-nav rw-selected=1></admin-left-nav></div><div><md-divider class=vertical-divider></md-divider></div><div flex=\"\"><div layout=row flex><md-card flex><md-card-title><md-card-title-text><span class=md-subhead style=\"text-align: center\">ŞİKAYETLER</span></md-card-title-text></md-card-title><md-card-content flex><div id=gridContainer dx-data-grid=gridOptions></div></md-card-content></md-card></div><div layout=row><div flex=50><admin-complaint-view selected-complaint=selectedComplaint></admin-complaint-view></div><div flex=50><bim-model options=bimModelOptions complaint=selectedComplaint></bim-model></div></div></div></div><admin-footer admin-page-selected=0></admin-footer>");
$templateCache.put("app/admin/modules/complaint/statistic/admin.complaint.statistic.tpl.html","<style>md-content.md-default-theme {\n    background-color: #ededed;\n  }\n\n  md-divider {\n    color: #ededed;\n  }\n\n  md-card {\n    background-color: #fff;\n  }\n\n  md-card h2:first-of-type {\n    margin-top: 0;\n  }\n\n  md-toolbar .md-button.md-default-theme {\n    border-radius: 99%;\n  }\n\n  h2 {\n    font-weight: 400;\n  }\n\n  .md-toolbar-tools-bottom {\n    font-size: small;\n  }\n\n  .md-toolbar-tools-bottom :last-child {\n    opacity: 0.8;\n  }\n\n  md-toolbar:not(.md-hue-1),\n  .md-fab {\n    fill: #fff;\n  }\n\n  md-sidenav {\n    fill: #737373;\n  }\n\n  md-sidenav ng-md-icon {\n    position: relative;\n    top: 5px;\n  }\n\n  .user-avatar {\n    border-radius: 99%;\n  }</style><div layout=row flex><!--<admin-loading></admin-loading>--><admin-header rw-selected=4></admin-header><div layout=column><admin-left-nav rw-selected=4></admin-left-nav></div><div><md-divider class=vertical-divider></md-divider></div><div layout=row><div layout=50 flex><md-card flex><md-card-title><div><md-input-container><label>Başlangıç Tarihi</label><md-datepicker ng-model=startDate1 md-placeholder=\"Başlangıc Tarihi\" md-max-date=endDate1></md-datepicker></md-input-container><md-input-container><label>Bitiş Tarihi</label><md-datepicker ng-model=endDate1 md-min-date=startDate1 md-placeholder=\"Bitiş Tarihi\"></md-datepicker></md-input-container><md-button class=\"md-raised md-primary\" style=margin-top:-18px!important ng-click=onDateChange1()>Filtrele</md-button></div></md-card-title><md-card-content flex><div layout=row><div id=chart dx-chart=chartOptions1 flex-gt-md=45 flex=100></div></div></md-card-content></md-card></div><div layout=50 flex><md-card flex><md-card-title><div><md-input-container><label>Başlangıç Tarihi</label><md-datepicker ng-model=startDate2 md-placeholder=\"Başlangıc Tarihi\" md-max-date=endDate2></md-datepicker></md-input-container><md-input-container><label>Bitiş Tarihi</label><md-datepicker ng-model=endDate2 md-min-date=startDate2 md-placeholder=\"Bitiş Tarihi\"></md-datepicker></md-input-container><md-button class=\"md-raised md-primary\" style=margin-top:-18px!important ng-click=onDateChange2()>Filtrele</md-button></div></md-card-title><md-card-content flex><div layout=row flex><div id=chart2 dx-pie-chart=chartOptions2 flex-gt-md=45 flex=100></div></div></md-card-content></md-card></div></div></div><div style=\"visibility: hidden\"><bim-model options=bimModelOptions complaint=selectedComplaint></bim-model></div><admin-footer admin-page-selected=0></admin-footer>");
$templateCache.put("app/admin/modules/complaint/waiting/admin.complaint.waiting.tpl.html","<style>md-content.md-default-theme {\n    background-color: #ededed;\n  }\n\n  md-divider {\n    color: #ededed;\n  }\n\n  md-card {\n    background-color: #fff;\n  }\n\n  md-card h2:first-of-type {\n    margin-top: 0;\n  }\n\n  md-toolbar .md-button.md-default-theme {\n    border-radius: 99%;\n  }\n\n  h2 {\n    font-weight: 400;\n  }\n\n  .md-toolbar-tools-bottom {\n    font-size: small;\n  }\n\n  .md-toolbar-tools-bottom :last-child {\n    opacity: 0.8;\n  }\n\n  md-toolbar:not(.md-hue-1),\n  .md-fab {\n    fill: #fff;\n  }\n\n  md-sidenav {\n    fill: #737373;\n  }\n\n  md-sidenav ng-md-icon {\n    position: relative;\n    top: 5px;\n  }\n\n  .user-avatar {\n    border-radius: 99%;\n  }</style><div layout=row flex><admin-loading></admin-loading><admin-header rw-selected=2></admin-header><div layout=column><admin-left-nav rw-selected=2></admin-left-nav></div><div><md-divider class=vertical-divider></md-divider></div><div flex=\"\"><div layout=row flex><md-card flex><md-card-title><md-card-title-text><span class=md-subhead style=\"text-align: center\">ŞİKAYETLER</span></md-card-title-text></md-card-title><md-card-content flex><div id=gridContainer dx-data-grid=gridOptions></div></md-card-content></md-card></div><div layout=row><div flex=50><admin-complaint-view selected-complaint=selectedComplaint></admin-complaint-view></div><div flex=50><bim-model options=bimModelOptions complaint=selectedComplaint></bim-model></div></div></div></div><admin-footer admin-page-selected=0></admin-footer>");
$templateCache.put("app/main/directive/navs/leftnav/left_nav.tpl.html","<div layout=column><div><md-button style=\"min-width: 20px!important\" aria-label=Search ng-click=autorenew()><i class=material-icons>autorenew</i></md-button><md-divider></md-divider><div ng-show=locationShow><md-button style=\"min-width: 20px!important\" aria-label=Search ng-click=location_on()><i class=material-icons>location_on</i></md-button></div><md-divider></md-divider><div><md-button style=\"min-width: 20px!important\" aria-label=Search ng-click=zoom_in()><i class=material-icons>zoom_in</i></md-button></div><div><md-button style=\"min-width: 20px!important\" aria-label=Search ng-click=zoom_out()><i class=material-icons>zoom_out</i></md-button></div></div><!--<md-sidenav class=\"md-sidenav-left\" md-component-id=\"left\" md-disable-backdrop md-whiteframe=\"4\">--><!--<md-toolbar class=\"md-theme-light\">--><!--<div class=\"md-toolbar-tools\">--><!--<md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" ng-click=\"close()\">--><!--<md-icon class=\"md-default-theme\" class=\"material-icons\">&#xE5CD;</md-icon>--><!--</md-button>--><!--<span flex></span>--><!--<h2>--><!--<span>{{\'ln_n_side_title\' | translate}}</span>--><!--</h2>--><!--</div>--><!--</md-toolbar>--><!--<md-content layout-padding>--><!--<md-list>--><!--<md-list-item ng-click=\"navigateTo(\'data usage\', $event)\">--><!--<md-icon md-svg-icon=\"cached\"></md-icon>--><!--<p>Data Usage</p>--><!--</md-list-item>--><!--</md-list>--><!--</md-content>--><!--</md-sidenav>--></div>");}]);